
//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'
import * as moment from 'moment'

//#endregion

//#region Angular Imports

import { StateService, StateParams } from '@uirouter/angularjs'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/tag_box'

//#endregion


import { Activity } from '../../models/common/activity'
import { IUserSession } from '../../helpers/user-session'

import {
    DashboardModel,
    DashboardRequestModel,
    DashboardSaveModel,
    DashboardItemModel,
    DashboardColumnModel,
    DashboardRowModel,
    DescrModel,
    FileModel,
    DashboardDataModel,
    DashboardTileDataModel,
    DashboardCardDataModel,
    DashboardGaugeDataModel,
    DashboardGridDataModel,
    DashboardChartDataModel,
    DashboardMapDataModel,
    DashboardSchemaDataModel,
    DashboardChartSeries,
    DashboardGridColumnModel,
    ResponseModel,
    ResponseListModel
} from '../api/api.models'

import { Api, LocalDictionaryFactory } from '../api/api.module'

import { LoggerService } from '../common/common.module'
import { CommonHelper, ChartType, Buttons, TextAlign, CorrelationType } from '../../helpers/common-helper'
import { EventsNames } from '../../helpers/events-names'
import { FormButtonOptions } from '../common/form-button/form-button.directive'
import { i18n } from '../common/i18n/common.i18n'
import { DescrType } from '../common/select-add-descr/select-add-descr.directive'
import { ReferenceType, OpChangeState } from '../../models/common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Enums } from '../../models/common/enums'
import { OpLanguage } from '../../models/core/op-language'
import { MapSource } from './map/map.controller'

import { Md5 } from '../../helpers/md5-helper'
import { LocalizationHelper } from '../../helpers/localization-helper'
import { TemplateHelper, ConfigHelper } from '../../helpers'
import { OpDashboard } from '../../models/custom'
import { BackwardCompatibilityHelper } from '../../helpers/backward-compatibility-helper'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { DashboardCreateEditPopupOptions } from './create-edit-popup/create-edit-popup.controller'
import { DashboardService } from './dashboard.service'
import { DashboardDestinationLevelPopupOptions, DestinationLevelModel } from './destination-level-popup/destination-level-popup.controller'
import { IMRBaseControlDirectiveController } from '../common/base'

export interface DashboardDelay {
    time: number
}

export interface DashboardScope extends ng.IScope {
    model: DashboardModel
    originalModel: DashboardModel

    descriptions: DescrModel[]

    rowHeight: number | string
    dashboardStyle: any
    chart: DevExpress.viz.dxChart
    contentWidth: number
    isLoading: boolean
    isDashboardLoading: boolean
    isEditPopupLoading: boolean

    gridsterItems: any[]
    gridsterOptions: any

    editGroupGridsterItems: any[]
    editGroupGridsterOptions: any

    isEditMode: boolean
    isEditPopupVisible: boolean
    beginEdit: () => void

    isEditGroup: boolean

    saveButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonOptions: DevExpress.ui.dxButtonOptions

    loadingTemplates: boolean
    dashboardTemplates: any[]

    addElement: (element: any) => void
    removeElement: (element: any) => void
    editElement: (element: any, column: any) => void
    editGroup: (element: any) => void

    editDashboardEnable: boolean
    editPopupOptions: DevExpress.ui.dxPopupOptions
    editElementPopupOptions: DevExpress.ui.dxPopupOptions
    templateSelectBoxOptions: any
    addTemplateButtonOptions: DevExpress.ui.dxButtonOptions
    isSelectedTemplate: boolean

    dashboardScrollOptions: DevExpress.ui.dxScrollViewOptions

    editDashboardModel: DashboardModel
    editDashboardButtonOptions: DevExpress.ui.dxButtonOptions
    deleteDashboardButtonOptions: DevExpress.ui.dxButtonOptions
    deleteElementButtonOptions: DevExpress.ui.dxButtonOptions
    delDashboardButtonVisible: boolean

    selectedDashboardType: number
    addDashboardButtonVisible: boolean
    addDashboardButtonOptions: DevExpress.ui.dxButtonOptions
    addDashboardPopupOptions: DevExpress.ui.dxPopupOptions
    addDashboardSelectboxOptions: DevExpress.ui.dxSelectBoxOptions
    addDashboardFormOptions: DevExpress.ui.dxFormOptions
    addDashboardModel: DashboardModel
    applyAddDashboardButtonOptions: DevExpress.ui.dxButtonOptions
    newDashboardModel: DashboardModel
    dashboardDescriptions: DescrModel[]

    cancelEditedGroupButtonOptions: DevExpress.ui.dxButtonOptions

    createEditDashboardCallback: (opDashboard: OpDashboard) => void
    deleteDashboardCallback: (opDashboard: OpDashboard) => void

    isApplyButtonClicked: boolean

    editedItem: DashboardItemModel & DashboardColumnModel
    newItem: DashboardItemModel
    editGroupFormOptions: DevExpress.ui.dxFormOptions
    editDashboardFormOptions: DevExpress.ui.dxFormOptions
    applyEditedGroupButtonOptions: DevExpress.ui.dxButtonOptions
    applyEditedElementButtonOptions: DevExpress.ui.dxButtonOptions
    listOfDashboardElementsOptions: DevExpress.ui.dxSelectBoxOptions
    onDescrSelectionChanged: (elementId: number, propertyName: string, descr: DescrModel) => void
    onDashboardDescrSelectionChanged: (elementId: number, propertyName: string, descr: DescrModel) => void
    onFileSelectionChanged: (elementId: number, propertyName: string, file: FileModel) => void
    onScriptChanged: (elementId: number, propertyName: string, script: string) => void
    onReferenceObjectChanged: (selectedId: number, dataTypeId: number, selectedName: string, propertyName: string) => void
    onDataTypeChanged: (selectedId: number, dataTypeId: number, selectedName: string, propertyName: string, selectedObj: any) => void
    onGridColumnDataTypeChanged: (selectedId: number, dataTypeId: number, selectedName: string, propertyName: string, selectedObj: any) => void
    onFormButtonClicked: (options: FormButtonOptions) => void

    checkRowCountInGroup: (column: DashboardColumnModel) => number

    operatorId: number
    distributorId: number

    loggedOperatorId: number
    downloadedDashboard: boolean

    editElementButtonOptions: DevExpress.ui.dxButtonOptions

    createEditDashboardOptions: DashboardCreateEditPopupOptions

    destinationLevelPopupOptions: DashboardDestinationLevelPopupOptions
}

interface ExtendedFormSimpleItem extends DevExpress.ui.dxFormSimpleItem {
    formItemValidateBy?: string
    formItemId?: number
}

export const DashboardRefreshControlDelay = 200

export class DashboardController extends IMRBaseControlDirectiveController {

    //#region Consts

    // Used to distinguish main gridster from gridsters inside items.
    private static get GRIDSTER_NAME() { return 'GRIDSTER_CONTAINER' }

    private static get INITIAL_GRIDSTER_HEIGHT() { return 10 }

    //#endregion


    //#region Members

    private isDashboardMobileMode: boolean

    //#endregion

    private needUpdateMenu: boolean
    private originalGridsterItems: any[]
    dashboardMd5: string = null
    templateSelectBox: DevExpress.ui.dxSelectBox
    addTemplateButton: DevExpress.ui.dxButton
    destinationLevelPopup: DevExpress.ui.dxPopup
    selectedItem: any
    previousWindowHeight: number

    editPopup: DevExpress.ui.dxPopup
    editElementPopup: DevExpress.ui.dxPopup

    editGroupForm: DevExpress.ui.dxForm
    editGroupFormDefer: ng.IDeferred<DevExpress.ui.dxForm>

    applyEditedGroupButton: DevExpress.ui.dxButton
    cancelEditedGroupButton: DevExpress.ui.dxButton
    editDashboardButton: DevExpress.ui.dxButton
    applyDashboardButton: DevExpress.ui.dxButton
    addDashboardButton: DevExpress.ui.dxButton
    applyEditedElementButton: DevExpress.ui.dxButton
    listOfDashboardElements: DevExpress.ui.dxSelectBox
    deleteElementButton: DevExpress.ui.dxButton

    selectedProfile: number

    mobileBreakPoint = 768

    editedGroup: any
    groupIds: number[]
    activeViews: any[]
    loggedUser: any

    languages: OpLanguage[]

    templateRequestPromise

    enableTileGridsterEdit: boolean
    updateDashboardItemsTimeout: any

    startupSerieSelectBox: DevExpress.ui.dxSelectBox

    types = [
        {
            value: 'System.String',
            caption: i18n('Common', 'Text'),
            idDataTypeClass: 3
        },
        {
            value: 'System.Int64',
            caption: i18n('Common', 'LongInteger'),
            idDataTypeClass: 1
        },
        {
            value: 'System.Int32',
            caption: i18n('Common', 'Integer'),
            idDataTypeClass: 1
        },
        {
            value: 'System.Double',
            caption: i18n('Common', 'Real'),
            idDataTypeClass: 2
        },
        {
            value: 'System.Date',
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Date),
            idDataTypeClass: 4
        },
        {
            value: 'System.Time',
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Time),
            idDataTypeClass: 5
        },
        {
            value: 'System.DateTime',
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DateTime),
            idDataTypeClass: 6
        },
        {
            value: 'System.Boolean',
            caption: i18n('Common', 'TypeBoolean'),
            idDataTypeClass: 7
        }
    ]

    textAlign = [
        {
            value: i18n('Common', 'Default'),
            id: TextAlign.Unknown
        },
        {
            value: i18n('Common', 'Left'),
            id: TextAlign.Left
        },
        {
            value: i18n('Common', 'Right'),
            id: TextAlign.Right
        },
        {
            value: i18n('Common', 'Center'),
            id: TextAlign.Center
        }
    ]

    correlationType = [{
        value: i18n('Common', 'None'),
        id: CorrelationType.None
    }, {
        value: i18n('Common', 'Local'),
        id: CorrelationType.Local
    }, {
        value: i18n('Common', 'Server'),
        id: CorrelationType.Server
    }]

    positionList = [{
        value: i18n('Common', 'None'),
        id: Enums.Alignment.Unknown
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Center),
        id: Enums.Alignment.Center
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Left),
        id: Enums.Alignment.Left
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Top),
        id: Enums.Alignment.Top
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Right),
        id: Enums.Alignment.Right
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Bottom),
        id: Enums.Alignment.Bottom
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TopLeft),
        id: Enums.Alignment.TopLeft
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TopRight),
        id: Enums.Alignment.TopRight
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BottomLeft),
        id: Enums.Alignment.BottomLeft
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BottomRight),
        id: Enums.Alignment.BottomRight
    }]

    iconStretch = [{
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.None),
        id: Enums.Stretch.None
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Fill),
        id: Enums.Stretch.Fill
    }, {
        value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Uniform),
        id: Enums.Stretch.Uniform
    }]

    constructor(private $scope: DashboardScope, private $state: StateService, private $q: ng.IQService, private $timeout: ng.ITimeoutService, private $location: ng.ILocationService, private api: Api, private logger: LoggerService, private localDictionary: LocalDictionaryFactory, private $stateParams: StateParams, private userSession: IUserSession, private dashboardService: DashboardService) {
        super()

        this.templateRequestPromise = $q.defer()
        this.originalGridsterItems = []
        this.loggedUser = api.login.getUser()

        $scope.isDashboardLoading = true
        $scope.isEditMode = false
        $scope.isEditPopupVisible = false
        $scope.loggedOperatorId = this.loggedUser.id
        $scope.distributorId = this.loggedUser.idDistributor

        $scope.addDashboardButtonVisible = userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_ADD)
        $scope.delDashboardButtonVisible = userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_DEL)
        $scope.editDashboardEnable = userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_CONFIGURATION)

        // Check if logger user has permission to configuration dashboard
        if ($scope.editDashboardEnable) {
            $scope.loadingTemplates = true

            api.dashboard.getDashboardTemplates().then((result) => {
                let controls = []
                $scope.dashboardTemplates = []

                result.forEach(dashboard => {
                    dashboard.rows.forEach(row => {
                        row.columns.forEach(column => {
                            controls.push(column)
                        })
                    })
                })

                $scope.dashboardTemplates.push({
                    key: 'Templates',
                    items: controls
                })

                if (this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_ITEM_CONFIGURATION)) {
                    $scope.dashboardTemplates.push({
                        key: 'Others',
                        items: [{
                            height: 30,
                            borderVisible: true,
                            items: [],
                            opState: CommonHelper.ChangeState.New,
                            size: 4,
                            title: i18n('Common', 'NewElement'),
                            isTemplate: false
                        }]
                    })
                }
                this.templateRequestPromise.resolve()
            }).catch(() => {
                this.templateRequestPromise.reject()
            }).finally(() => {
                $scope.loadingTemplates = false
            })
        }

        this.userSession.getDataProvider().System.getDictionaries([Enums.ReferenceType.IdLanguage]).then(dictionaries => {
            if (dictionaries.containsKey(Enums.ReferenceType.IdLanguage)) {
                this.languages = <OpLanguage[]>dictionaries.tryGetValue(Enums.ReferenceType.IdLanguage).values()
            } else {
                console.warn("Dictionaries for languages not exist", Enums.ReferenceType.IdLanguage)
                this.languages = []
            }
        })

        $scope.$on(EventsNames.BEGIN_DASHBOARD_EDIT, () => {
            if ($scope.isEditMode)
                return

            this.toggleDashboardEditMode(true)
            this.refreshDashboard()
        })

        $scope.$on(EventsNames.UPDATE_DASHBOARD_ITEM_WS, (event, ...args) => {
            var gridId, dashboardItem: DashboardItemModel = null
            if (args && args[0]) gridId = args[0]
            if (gridId) {
                $scope.gridsterItems.forEach(gridster => {
                    gridster.items.forEach(item => {
                        if (item.id == gridId) {
                            dashboardItem = item
                            return
                        }
                    })
                    if (dashboardItem) return
                })

                if (dashboardItem && dashboardItem.type == CommonHelper.DashboardItemType.Grid) {
                    const dashboardItemGroupId: number = this.getDashboardItemModelGroupId(dashboardItem)

                    if (dashboardItemGroupId != null) {
                        const dataRequest = new DashboardRequestModel();

                        dataRequest.groupId = dashboardItemGroupId
                        dataRequest.idDashboard = this.$scope.model.idDashboard
                        dataRequest.ids = [gridId]

                        this.api.dashboard
                            .getDashbordItems(dataRequest)
                            .then((result: ResponseListModel<any>) => {
                                if (result && result.result && !result.errorMessage) {
                                    dashboardItem.data = <DashboardDataModel>result.result[0]
                                    this.updateDashboardItems(dashboardItem.id)

                                    this.originalGridsterItems.forEach(gridster => {
                                        gridster.items.forEach(item => {
                                            if (item.id == gridId) {
                                                item.data = dashboardItem.data
                                            }
                                        })
                                    })
                                }
                            })
                    }
                }
            }
        })

        $scope.templateSelectBoxOptions = {
            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
            placeholder: i18n('Common', 'SelectTemplate'),
            displayExpr: 'title',
            grouped: true,
            groupTemplate: data => {
                return i18n('Common', data.key)
            },
            width: 300,
            bindingOptions: {
                dataSource: 'dashboardTemplates',
                disabled: '!model.id'
            },
            onSelectionChanged: (e: any) => {
                if (e.selectedItem) {
                    $scope.isSelectedTemplate = true
                    this.selectedItem = e.selectedItem
                }
                else {
                    $scope.isSelectedTemplate = false
                    this.selectedItem = null
                }
            },
            onInitialized: (e: any) => {
                this.templateSelectBox = e.component;
            }
        }

        this.

            $scope['isAddTemplateButtonDisabled'] = () => {
                return !$scope.isSelectedTemplate
            }

        const getFirstAvailableGroupId = () => {
            let newGroupId = $scope.gridsterItems.length

            let sortedItems = _.sortBy($scope.gridsterItems.concat($scope.dashboardTemplates[0].items), item => item.groupId)
            for (let i = 0; i < sortedItems.length; i++) {
                let notAvailable = null
                for (let j = 0; j < sortedItems.length; j++) {
                    if (i == sortedItems[j].groupId) {
                        notAvailable = true
                        break
                    }
                }

                if (!notAvailable) {
                    newGroupId = i
                    break
                }
            }

            return newGroupId
        }

        $scope.addTemplateButtonOptions = {
            text: i18n('Common', 'Select'),
            onClick: (e: any) => {
                this.selectedItem.opState = CommonHelper.ChangeState.New
                if (!this.selectedItem.isTemplate) {
                    const newGroupId = getFirstAvailableGroupId()

                    this.selectedItem.groupId = newGroupId
                    this.selectedItem.descr = <DescrModel>{
                        description: i18n('Common', 'Group') + ' ' + newGroupId,
                        idDescr: 0,
                        idLanguage: 1,
                        opState: CommonHelper.ChangeState.New
                    }

                    this.selectedItem.descr.allLanguagesDescription = [$.extend(true, {}, this.selectedItem.descr)]
                    this.addNewItemToGridster($.extend(true, {}, this.selectedItem))
                    $scope.addElement(this.selectedItem)
                }
                else {
                    let item = _.find($scope.dashboardTemplates[0].items, (template: any) => template.groupId == this.selectedItem.groupId)

                    const newGroupId = getFirstAvailableGroupId()

                    this.selectedItem.groupId = newGroupId

                    // Set idGroupDescr to 0 and state to New
                    if (this.selectedItem.descr) {
                        //this.selectedItem.descr.idDescr = 0 I don't know how it's work but...
                        this.selectedItem.descr.opState = CommonHelper.ChangeState.New
                    }

                    // Set idType to 0 and state to New
                    if (this.selectedItem.items) {
                        this.selectedItem.items = this.selectedItem.items.map(control => {
                            if (control.descr) {
                                control.descr = <DescrModel>{
                                    description: control.descr.description,
                                    idDescr: control.descr.idDescr, // 0, I don't know how it's work but...
                                    opState: CommonHelper.ChangeState.New,
                                    idLanguage: control.descr.idLanguage,
                                    allLanguagesDescription: control.descr.allLanguagesDescription.map(allLangDescr => {
                                        allLangDescr.idDescr = 0
                                        allLangDescr.opState = CommonHelper.ChangeState.New
                                        return allLangDescr
                                    })
                                }
                            }
                            return control
                        })
                    }

                    this.addNewItemToGridster($.extend(true, {}, this.selectedItem), true)
                    this.templateSelectBox.option('value', null)
                }
            },
            onInitialized: (e: any) => {
                this.addTemplateButton = e.component
            },
            bindingOptions: {
                disabled: 'isAddTemplateButtonDisabled()'
            }
        }

        $scope.editGroup = (element: any) => {
            $scope.isEditPopupLoading = true
            this.editPopup.show().then(() => {
                $scope.editedItem = jQuery.extend(true, {}, element)
                let formItems = [
                    {
                        dataField: 'descr',
                        label: {
                            text: i18n('Common', 'Title')
                        },
                        template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.descr' : 'newItem.descr') + '" element-id="' + element.id + '" descriptions="descriptions" property-name="descr" type="' + DescrType.ItemType + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                    },
                    {
                        dataField: 'borderVisible',
                        label: {
                            text: i18n('Common', 'BorderVisible')
                        },
                        editorOptions: {

                            onValueChanged: (e: any) => {
                                if ($scope.editedItem)
                                    $scope.editedItem.borderVisible = e.value
                            }
                        }
                    },
                    {
                        dataField: 'refreshPeriod',
                        label: {
                            text: i18n('Common', 'RefreshPeriod') + ' [s]'
                        },
                        editorType: 'dxNumberBox',
                        editorOptions: {
                            onValueChanged: (e: any) => {
                                if ($scope.editedItem)
                                    $scope.editedItem.refreshPeriod = e.value * 1000
                            }
                        }
                    }
                ]
                let formData = {
                    title: $scope.editedItem.title,
                    borderVisible: $scope.editedItem.borderVisible,
                    refreshPeriod: ($scope.editedItem.refreshPeriod / 1000)
                }

                this.editGroupFormDefer.promise.then(form => {
                    form.option({
                        'formData': {},
                        'items': []
                    })

                    $timeout(() => {
                        form.option({
                            'formData': formData,
                            'items': formItems
                        })

                        const groupHeight: number = angular.element('.edit-group-body').height() - 50 // 30px is padding

                        $scope.editGroupGridsterOptions = this.getGroupGridsterOptions(element, groupHeight)
                        if (element.items) {
                            $scope.editGroupGridsterItems = element.items.map(item => {
                                const extendedItem = _.assign(item, {
                                    col: undefined,
                                    row: undefined,
                                    sizeX: item.size,
                                    sizeY: 1
                                })
                                return extendedItem
                            })
                        }
                        $scope.isEditPopupLoading = false

                        $timeout(() => {
                            element.items.forEach(item => this.updateDashboardItems(item.id))
                        }, 500)
                    })
                })
            })
        }

        $scope.addElement = (element: any) => {
            this.editGroupFormDefer = $q.defer<DevExpress.ui.dxForm>()
            $scope.isEditPopupLoading = true
            this.editElementPopup.option('title', i18n('Common', 'ElementCreate'))
            this.editElementPopup.show().then(() => {
                this.editedGroup = $.extend(true, {}, element)

                $scope.isEditPopupLoading = false
            })
        }

        $scope.removeElement = (element: any) => {
            let foundEl = _.find(this.$scope.gridsterItems, item => item.groupId == element.groupId)
            this.templateRequestPromise.promise.then(() => {
                let item = _.find($scope.dashboardTemplates[0].items, (template: any) => template.groupId == foundEl.groupId)
                if (item)
                    item.disabled = false
            })

            if (foundEl.opState == CommonHelper.ChangeState.New) {
                let index = this.$scope.gridsterItems.indexOf(foundEl)
                this.$scope.gridsterItems.splice(index, 1)

                this.onDashboardItemRemoved()

                return
            }

            foundEl.opState = CommonHelper.ChangeState.Delete

            this.onDashboardItemRemoved()
        }

        $scope.editElement = (element, column) => {
            this.editGroupFormDefer = $q.defer<DevExpress.ui.dxForm>()
            var dashboardItems: any[] = $.map(CommonHelper.DashboardItemType, (value, index) => {
                return {
                    caption: i18n('Common', index),
                    value: value
                }
            })

            $scope.isEditPopupLoading = true
            this.editElementPopup.option('title', i18n('Common', 'ElementEdit') + ' (' + _.find(dashboardItems, item => item.value == element.type).caption + ')')
            this.editElementPopup.show().then(() => {
                $scope.editedItem = jQuery.extend(true, {}, element)
                this.editedGroup = $.extend(true, {}, column)
                this.createFormDataForElement($scope.editedItem)
                $scope.isEditPopupLoading = false
            })
        }

        $scope.saveButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Save),
            bindingOptions: {
                disabled: '!model.id'
            },
            onClick: (e: any) => {
                this.showDestinationLevelPopup()
            }
        }

        $scope.cancelButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
            onClick: (e: any) => {
                this.toggleDashboardEditMode(false)

                const md5 = Md5.init(JSON.stringify($scope.model))
                $scope.model = null
                $timeout(() => {
                    $scope.model = jQuery.extend(true, {}, $scope.originalModel)
                    if (md5 != this.dashboardMd5) {
                        this.updateItems()
                        this.dashboardMd5 = md5
                    }

                    this.updateDashboardStyles($scope.model)
                    this.refreshDashboard()
                }, 1000)
            }
        }

        // end confirmation popup

        // edit group/element popup

        $scope.deleteElementButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, userSession),
            hint: i18n('Common', 'Delete'),
            height: 34,
            width: 60,
            onInitialized: (e: any) => {
                this.deleteElementButton = e.component
            },
            onClick: (e: any) => {
                for (let i = 0; i < $scope.gridsterItems.length; i++) {
                    let gridsterItem = $scope.gridsterItems[i]
                    let foundItem = _.find(gridsterItem.items, ((item: any) => {
                        return item.id == $scope.editedItem.id && item.opState != CommonHelper.ChangeState.Delete && item.type == $scope.editedItem.type
                    }))

                    if (foundItem) {
                        foundItem.opState = CommonHelper.ChangeState.Delete
                        break
                    }
                }

                this.refreshDashboard()
                this.editElementPopup.hide()
            }
        }

        $scope.listOfDashboardElementsOptions = {
            items: $.map(CommonHelper.DashboardItemType, (value, index) => {
                return {
                    caption: i18n('Common', index),
                    value: value
                }
            }),
            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
            displayExpr: 'caption',
            valueExpr: 'value',
            onInitialized: (e: any) => {
                this.listOfDashboardElements = e.component
            },
            onValueChanged: (e: any) => {
                $scope.newItem = null

                this.editGroupFormDefer = $q.defer<DevExpress.ui.dxForm>()

                $timeout(() => {
                    if ([undefined, null].indexOf(e.value) < 0) {
                        let nextIndex = 0
                        if (this.editedGroup.items && this.editedGroup.items.length > 0) {
                            nextIndex = _.max(this.editedGroup.items, (item: any) => item.indexNbr).indexNbr + 1
                        }

                        const descr = {
                            description: 'dc_' + e.value + '_' + new Date().getTime(),
                            idDescr: 0,
                            idLanguage: this.userSession.getDataProvider().System.getCurrentLanguageId(),
                            opState: CommonHelper.ChangeState.New,
                            allLanguagesDescription: []
                        }

                        const newDescr = $.extend(true, {}, descr)

                        if (!this.languages)
                            this.languages = []

                        this.languages.forEach(language => {
                            var descrLang = $.extend(true, {}, descr)
                            descrLang.idLanguage = language.idLanguage
                            newDescr.allLanguagesDescription.push(descrLang)
                        })

                        $scope.newItem = <DashboardItemModel>{
                            type: e.value,
                            id: -new Date().getTime(), //need for separating new added items
                            isCustomizable: true,
                            opState: CommonHelper.ChangeState.New,
                            script: '',
                            indexNbr: nextIndex,
                            size: 12,
                            descr: newDescr,
                            data: null
                        }

                        switch (e.value) {
                            case CommonHelper.DashboardItemType.Tile:
                                $scope.newItem.data = <DashboardTileDataModel>{ id: $scope.newItem.id, amountVisible: false, iconVisible: false, texHeaderVisible: false, borderRadius: [0, 0, 0, 0], titlePosition: Enums.Alignment.Center, valuePosition: Enums.Alignment.Center, iconPosition: Enums.Alignment.Center, correlationType: CorrelationType.None, iconStretch: Enums.Stretch.None }
                                break
                            case CommonHelper.DashboardItemType.Gauge:
                                $scope.newItem.data = <DashboardGaugeDataModel>{ id: 0, min: 0, max: 100, ranges: [{ minValue: 0, maxValue: 80, color: '#FF0000' }, { minValue: 80, maxValue: 90, color: '#FFFF00' }, { minValue: 90, maxValue: 100, color: '#00FF00' }] }
                                break
                            case CommonHelper.DashboardItemType.Chart:
                                $scope.newItem.data = <DashboardChartDataModel>{ id: 0, correlationType: CorrelationType.None, series: [<DashboardChartSeries>{ xTypeName: 'System.Int32', yTypeName: 'System.Int32' }], titlePosition: Enums.Alignment.Center, isLegendValueVisible: true, isSeriesLabelVisible: true, isTooltipHidden: false, isYAxisTitleHidden: false, isXAxisTitleHidden: false, isVerticalGridHidden: false, isHorizontalGridHidden: false }
                                break
                            case CommonHelper.DashboardItemType.Schema:
                                $scope.newItem.data = <DashboardSchemaDataModel>{ id: 0, correlationType: CorrelationType.None }
                                break
                            case CommonHelper.DashboardItemType.Card:
                                $scope.newItem.data = <DashboardCardDataModel>{ id: 0, option: 1, referenceType: CommonHelper.IdOperator }
                                break
                            case CommonHelper.DashboardItemType.Grid:
                                $scope.newItem.data = <DashboardGridDataModel>{ id: 0, correlationType: CorrelationType.None, contextMenuEnabled: false, columns: [{ dataField: 'field1' }, { dataField: 'field2' }, { dataField: 'field3' }] }
                                break
                            case CommonHelper.DashboardItemType.Map:
                                $scope.newItem.data = <DashboardMapDataModel>{ id: 0, correlationType: CorrelationType.None, iconDict: {}, interaction: Enums.MapInteractionType.MarkerBounce }
                                break
                        }

                        this.createFormDataForElement($scope.newItem)
                    }
                    else {
                        $scope.newItem = null
                    }
                })
            }
        }

        $scope.editPopupOptions = {
            title: i18n('Common', 'GroupEdit'),
            showCloseButton: true,
            onInitialized: (e: any) => {
                this.editPopup = e.component
            },
            onShowing: () => {
                this.editGroupFormDefer = $q.defer<DevExpress.ui.dxForm>()
                this.$scope.isEditGroup = true
            },
            onHidden: () => {
                $scope.editedItem = null
                $scope.newItem = null

                $scope.editGroupGridsterItems = null
                $scope.editGroupGridsterOptions = null
            }
        }

        $scope.editElementPopupOptions = {
            title: i18n('Common', 'ElementEdit'),
            onInitialized: (e: any) => {
                this.editElementPopup = e.component
            },
            onShowing: () => {
                this.editGroupFormDefer = $q.defer<DevExpress.ui.dxForm>()
                this.$scope.isEditGroup = false
            },
            onHiding: () => {
                this.enableTileGridsterEdit = false
                this.toggleTileGridsterEdit(this.enableTileGridsterEdit)
                const found = $scope.gridsterItems[$scope.gridsterItems.length - 1]
                if (found && found.opState == CommonHelper.ChangeState.New && !found.isApplied)
                    $scope.gridsterItems.splice(-1, 1)
            },
            onHidden: () => {
                $scope.editedItem = null
                $scope.newItem = null

                this.listOfDashboardElements.option('value', null)
            }
        }

        this.editGroupFormDefer = $q.defer<DevExpress.ui.dxForm>()

        $scope.editGroupFormOptions = {
            colCount: 1,
            onInitialized: (e: any) => {
                this.editGroupForm = e.component
                this.editGroupFormDefer.resolve(this.editGroupForm)
            },
            scrollingEnabled: true,
            height: '100%',
            onFieldDataChanged: _.debounce((e: any) => {
                let eItem = $scope.editedItem ? $scope.editedItem : $scope.newItem
                if (eItem && eItem.data) {
                    this.updateDashboardItems(eItem.data.id)
                }
            }, 500)
        }

        $scope.applyEditedGroupButtonOptions = {
            text: i18n('Common', 'Apply'),
            height: 34,
            onInitialized: (e: any) => {
                this.applyEditedGroupButton = e.component
            },
            onClick: (e: any) => {
                if ($scope.editedItem) {
                    _.forEach($scope.gridsterItems, item => {
                        if (item.groupId == $scope.editedItem.groupId) {
                            let rows = _.groupBy($scope.editGroupGridsterItems, item => item.row)
                            const indexes = _.sortBy($scope.editGroupGridsterItems.map(gridsterItem => gridsterItem.indexNbr), index => index)

                            $scope.editedItem.opState = CommonHelper.ChangeState.Modified
                            item = _.assign(item, $scope.editedItem)

                            let ind = 0
                            item.items = []

                            for (let i in rows) {
                                const row = rows[i]
                                const columns = _.sortBy(row, r => r.col)

                                for (let j in columns) {
                                    let column = columns[j]
                                    column.col = undefined
                                    column.row = undefined
                                    column.sizeX = undefined
                                    column.sizeY = undefined
                                    if (column.data.option != 1) { //Keeper
                                        column.opState = CommonHelper.ChangeState.Modified
                                    }
                                    column.indexNbr = indexes[ind++]

                                    item.items.push(column)
                                }
                            }
                        }
                    })

                    this.updateDashboardItems($scope.editedItem.id)

                    $scope.editedItem = null
                }

                this.editPopup.hide()
            }
        }

        this.initializeScrollView()

        $scope.cancelEditedGroupButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
            height: 34,
            onInitialized: (e: any) => {
                this.cancelEditedGroupButton = e.component
            },
            onClick: (e: any) => {
                this.editPopup.hide()
                this.editElementPopup.hide()

                $scope.editedItem = null
            }
        }

        $scope.editElementButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DASHBOARD, this.userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit),
            height: 34,
            width: 34,
            onClick: (e: any) => {
                this.enableTileGridsterEdit = !this.enableTileGridsterEdit
                this.toggleTileGridsterEdit(this.enableTileGridsterEdit)
            }
        }

        const getValueFromObject = (object: Object, keyPath: string) => {
            return keyPath.split(".").reduce((prev: Object, curr: string) => {
                if (prev == null) {
                    return null;
                }
                return prev[curr]
            }, object);
        }

        const validateFormItems = (data: Object, items: DevExpress.ui.dxFormSimpleItem[]) => {
            return items.every((item: DevExpress.ui.dxFormSimpleItem) => {
                if (item.itemType == 'group') {
                    const dxFormGroupItem: DevExpress.ui.dxFormGroupItem = item
                    if (!validateFormItems(data, dxFormGroupItem.items)) {
                        return false
                    }
                } else {
                    const extendedFormSimpleItem: ExtendedFormSimpleItem = item as ExtendedFormSimpleItem
                    if (extendedFormSimpleItem.isRequired && extendedFormSimpleItem.dataField != null) {
                        const path: string = extendedFormSimpleItem.formItemValidateBy == null ? extendedFormSimpleItem.dataField.replace('[', '.').replace(']', '') : extendedFormSimpleItem.formItemValidateBy
                        if (getValueFromObject(data, path) == null) {
                            if (extendedFormSimpleItem.formItemId) {
                                $("[datatype-id=" + extendedFormSimpleItem.formItemId + "] .select-container").addClass('dx-invalid dx-texteditor')
                                $("[datatype-id=" + extendedFormSimpleItem.formItemId + "] .select-button").addClass('dx-invalid dx-texteditor')
                            }
                            return false
                        }
                    }
                }
                return true
            })
        }

        $scope.applyEditedElementButtonOptions = {
            text: i18n('Common', 'Apply'),
            height: 34,
            onInitialized: (e: any) => {
                this.applyEditedElementButton = e.component
            },
            onClick: (e: any) => {
                const validate = <any>this.editGroupForm.validate()
                if (validate && !validate.isValid) {
                    CommonHelper.openInfoPopup(i18n('Common', 'FillAllRequiredFields'), 'error', 4000)
                    return
                }

                this.editGroupFormDefer.promise.then((form: DevExpress.ui.dxForm) => {
                    const items: DevExpress.ui.dxFormSimpleItem[] = form.option('items')

                    if (!$scope.editedItem) {
                        if (!validateFormItems($scope.newItem.data, items)) {
                            CommonHelper.openInfoPopup(i18n('Common', 'FillAllRequiredFields'), 'error', 4000)
                            return
                        }
                        let validatedColumns: DashboardGridColumnModel[] = []
                        if ($scope.newItem.type == 3) {
                            const dashboardGridDataModel: DashboardGridDataModel = $scope.newItem.data as DashboardGridDataModel
                            validatedColumns = dashboardGridDataModel.columns.filter(column => (column.dataField == "" || column.type == "" || !column.caption))
                        }

                        if (!$scope.newItem.descr || ($scope.newItem.type == 3 && validatedColumns.length != 0)) {
                            CommonHelper.openInfoPopup(i18n('Common', 'FillAllRequiredFields'), 'error', 4000)
                        }
                        else {
                            const gridsterItem: DashboardColumnModel = _.find($scope.gridsterItems, (item: DashboardColumnModel) => item.groupId == this.editedGroup.groupId)
                            if (gridsterItem) {
                                gridsterItem.isApplied = true
                                gridsterItem.items.push($.extend(true, {}, $scope.newItem))
                                this.refreshDashboard()
                            }

                            this.editElementPopup.hide().then(() => {
                                $scope.newItem = null
                            })
                        }
                    }
                    else {
                        if (!validateFormItems($scope.editedItem.data, items)) {
                            CommonHelper.openInfoPopup(i18n('Common', 'FillAllRequiredFields'), 'error', 4000)
                            return
                        }
                        let validatedColumns: DashboardGridColumnModel[] = []
                        if ($scope.editedItem.type == 3) {
                            const dashboardGridDataModel: DashboardGridDataModel = $scope.editedItem.data as DashboardGridDataModel
                            validatedColumns = dashboardGridDataModel.columns.filter(column => (column.dataField == "" || column.type == "" || !column.caption))
                        }
                        if (!$scope.editedItem.descr || ($scope.editedItem.type == 3 && validatedColumns.length != 0)) {
                            CommonHelper.openInfoPopup(i18n('Common', 'FillAllRequiredFields'), 'error', 4000)
                        }
                        else {
                            $scope.gridsterItems.forEach((gridsterItem: DashboardColumnModel) => {
                                gridsterItem.items.forEach((item: DashboardItemModel) => {
                                    if (item.id == $scope.editedItem.id && item.type == $scope.editedItem.type) {
                                        $scope.editedItem.opState = CommonHelper.ChangeState.Modified
                                        item = _.assign(item, $scope.editedItem)
                                        this.updateDashboardItems(item.id, item.data)
                                        return
                                    }
                                })
                            })
                            $scope.editedItem = null
                            this.editElementPopup.hide()
                        }
                    }
                })
            }
        }

        $scope.onDescrSelectionChanged = (elementId: number, propertyName: string, descr: DescrModel) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            CommonHelper.setPropertyInObject(eItem, propertyName, descr)
            this.updateDashboardItems(elementId)
        }

        $scope.onDashboardDescrSelectionChanged = (elementId: number, propertyName: string, descr: DescrModel) => {
            if (this.$scope.addDashboardModel)
                this.$scope.addDashboardModel.nameDescriptions = descr
            if (this.$scope.editDashboardModel)
                this.$scope.editDashboardModel.nameDescriptions = descr
        }

        $scope.onFileSelectionChanged = (elementId: number, propertyName: string, file: FileModel) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            CommonHelper.setPropertyInObject(eItem.data, propertyName, file)
            this.updateDashboardItems(elementId)
        }

        $scope.onScriptChanged = (elementId: number, propertyName: string, script: string) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            CommonHelper.setPropertyInObject(eItem, propertyName, script)
        }

        $scope.onReferenceObjectChanged = (selectedId: number, dataTypeId: number, selectedName: string, propertyName: string) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            if (selectedId && dataTypeId == CommonHelper.userColumnId) {
                CommonHelper.setPropertyInObject(eItem.data, 'referenceType', CommonHelper.IdOperator)

                api.users.getUser(selectedId).then(result => {
                    CommonHelper.setPropertyInObject(eItem.data, 'header', result.name)
                })
            }

            CommonHelper.setPropertyInObject(eItem, propertyName, selectedId)
        }

        $scope.onDataTypeChanged = (selectedId: number, dataTypeId: number, selectedName: string, propertyName: string, selectedItem: any) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            if (!propertyName)
                return

            this.localDictionary.getDataTypes([selectedId]).then(result => {
                const isX = propertyName.indexOf('xIdDataTypeFormat') > -1

                $timeout(() => {
                    if (result && result[0] && selectedName != i18n('Popup', 'LocationNothingSelected')) {
                        const type = _.find(this.types, t => t.idDataTypeClass == result[0].type)

                        if (type)
                            this.$scope[isX ? 'xTypeNameSelectBox' : 'yTypeNameSelectBox'].option('value', type.value)
                        this.$scope[isX ? 'xTypeNameSelectBox' : 'yTypeNameSelectBox'].option('disabled', true)

                    }
                    else {
                        this.$scope[isX ? 'xTypeNameSelectBox' : 'yTypeNameSelectBox'].option('value', null)
                        this.$scope[isX ? 'xTypeNameSelectBox' : 'yTypeNameSelectBox'].option('disabled', false)
                    }
                })
            })

            CommonHelper.setPropertyInObject(eItem, propertyName, selectedId)
        }

        $scope.onGridColumnDataTypeChanged = (selectedId: number, dataTypeId: number, selectedName: string, propertyName: string, selectedItem: any) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            if (!propertyName)
                return

            CommonHelper.setPropertyInObject(eItem, propertyName, selectedId)
        }

        $scope.onFormButtonClicked = (options: FormButtonOptions) => {
            let eItem = this.$scope.editedItem ? this.$scope.editedItem : this.$scope.newItem

            if (options.type == 'ADD') {
                if (!eItem.data[options.propertyName])
                    eItem.data[options.propertyName] = []
                let newObject = {}

                if (options.propertyName === 'columns') {
                    const lastColumn = _.last(eItem.data[options.propertyName])

                    newObject['dataField'] = lastColumn ? (lastColumn['dataField'] + 'x') : 'field1'
                }

                eItem.data[options.propertyName].push(newObject)
            }
            else if (options.type == 'DELETE') {
                if (eItem.data[options.propertyName]) {
                    eItem.data[options.propertyName].splice(options.index, 1)
                }
            }

            this.createFormDataForElement(eItem)
            this.updateDashboardItems(eItem.data.id)
        }

        // end edit group

        // edit dashboard options popup        

        $scope.editDashboardButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.EDIT, userSession),
            hint: i18n('Popup', 'EditDashboardOptions'),
            onInitialized: (e: any) => {
                this.editDashboardButton = e.component
            },
            bindingOptions: {
                disabled: '!model.id'
            },
            onClick: (e: any) => {
                const opDashboard: OpDashboard = BackwardCompatibilityHelper.DashboardModelToOpDashboard($scope.model)
                opDashboard.opState = Enums.OpChangeState.Modified

                $scope.createEditDashboardOptions = {
                    dashboardModel: opDashboard,
                    descriptions: $scope.descriptions,
                    isNew: false,
                    onSubmitCallback: $scope.createEditDashboardCallback
                }
            }
        }

        // add dashboard options popup
        $scope.addDashboardButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, this.userSession),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AddNewDashboard),
            onInitialized: (e: any) => {
                this.addDashboardButton = e.component
            },
            onClick: (e: any) => {
                const opDashboard: OpDashboard = new OpDashboard()
                opDashboard.opState = Enums.OpChangeState.New
                opDashboard.fitToScreen = false
                opDashboard.keepAspectRatio = false

                $scope.createEditDashboardOptions = {
                    dashboardModel: opDashboard,
                    descriptions: $scope.descriptions,
                    isNew: true,
                    onSubmitCallback: $scope.createEditDashboardCallback
                }
            }
        }

        $scope.createEditDashboardCallback = (opDashboard: OpDashboard) => {
            if (opDashboard.opState === Enums.OpChangeState.New) {
                $scope.addDashboardModel = BackwardCompatibilityHelper.opDashboardToDashboardModel(opDashboard)
                $scope.newDashboardModel = jQuery.extend(true, {}, $scope.addDashboardModel)
                this.showDestinationLevelPopup()
                $scope.addDashboardModel = null
            }
            if (opDashboard.opState === Enums.OpChangeState.Modified) {
                $scope.editDashboardModel = BackwardCompatibilityHelper.opDashboardToDashboardModel(opDashboard)
                $scope.editDashboardModel.rows = $scope.model.rows //!!TODO convert full OpDashbord <=> DashboardModel

                if (!$scope.editDashboardModel.nameDescriptions && !$scope.model.nameDescriptions) {
                    this.needUpdateMenu = false
                } else if ((!$scope.editDashboardModel.nameDescriptions && $scope.model.nameDescriptions) || ($scope.editDashboardModel.nameDescriptions && !$scope.model.nameDescriptions)) {
                    this.needUpdateMenu = true
                } else if ($scope.editDashboardModel.nameDescriptions.description != $scope.model.nameDescriptions.description) {
                    this.needUpdateMenu = true
                }

                $scope.model = jQuery.extend(true, {}, $scope.editDashboardModel)

                this.updateDashboardStyles($scope.model)

                this.toggleGridsterFitToScreenMode(this.$scope.model.fitToScreen)
                this.toggleGridsterKeepAspectRationMode(this.$scope.model.keepAspectRatio)

                this.refreshDashboard()

                $scope.editDashboardModel = null
            }
            if (opDashboard.opState === Enums.OpChangeState.Delete) {
                onDeleteDashboard(opDashboard)
            }
        }

        const onDeleteDashboard = (opDashboard: OpDashboard) => {
            const dashboardModel = new DashboardSaveModel()
            dashboardModel.configurationSourceId = opDashboard.configurationSourceId
            dashboardModel.configurationSourceLevel = opDashboard.configurationSourceLevel
            dashboardModel.id = opDashboard.idDashboard
            dashboardModel.destinationObject = api.login.getUser().id

            api.dashboard.deleteDashboardConfiguration(dashboardModel).then(result => {
                $scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
                if (!result.hasErrorCode) {
                    CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DashboardDeleted))
                    this.dashboardService.updateSidebarMenu(this.$scope.$root, this.userSession, opDashboard, true, this.needUpdateMenu).then(() => {
                        const filteredItems = MenuItem.getMenuItems().filter(item => item.state === 'dashboard')
                        if (filteredItems.length) {
                            const item = filteredItems[0]
                            $state.go(item.state, item.params)
                        }

                        DataProvider.Dashboard.refreshDashboards(api, true)
                        this.getDashboardConfig()
                    })
                } else {
                    this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                }
            }).finally(() => {
                $scope.editDashboardModel = null
                $scope.addDashboardModel = null
            })
        }

        $scope.deleteDashboardButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DELETE, userSession),
            hint: i18n('Common', 'Delete'),
            width: 60,
            height: 34,
            onClick: (e: any) => {
                $scope.isEditPopupLoading = true

                const dashboardModel = new DashboardSaveModel()
                dashboardModel.configurationSourceId = $scope.model.configurationSourceId
                dashboardModel.configurationSourceLevel = $scope.model.configurationSourceLevel
                dashboardModel.id = $scope.model.id
                dashboardModel.destinationObject = api.login.getUser().id

                api.dashboard.deleteDashboardConfiguration(dashboardModel).then(result => {
                    if (!result.hasErrorCode)
                        CommonHelper.openInfoPopup(i18n('Common', 'DashboardDeleted'))
                    this.getDashboardConfig()
                }).finally(() => {
                    $scope.editDashboardModel = null
                    $scope.isEditPopupLoading = false
                })
            }
        }

        // end edit dashboard options

        $scope.checkRowCountInGroup = (column: DashboardColumnModel) => {
            if (!column || !column.items || column.items.filter(item => item.opState != 4).length == 0)
                return 0

            var colSum = column.items.filter(item => item.opState != 4).map(item => item.size ? item.size : 12).reduce((acc, currentItem) => acc + currentItem)

            return Math.ceil(colSum / 12)
        }

        this.getDashboardConfig()

        $scope.$root.$broadcast(EventsNames.DISABLE_LOADING_INDICATOR)
        localDictionary.refreshDictionaries().then(() => {
            if ($scope.$root)
                $scope.$root.$broadcast(EventsNames.ENABLE_LOADING_INDICATOR)
        })

        $scope.contentWidth = this.getDashboardElement().width()

        this.initializeDashboard()
    }

    private getDashboardConfig = (): void => {
        this.$scope.model = null
        this.$scope.originalModel = null
        this.$scope.gridsterItems = []
        this.originalGridsterItems = []

        this.$scope.isDashboardLoading = true

        let id: string | number = this.$stateParams['id']
        if (!id || id == '')
            id = 0

        this.localDictionary.getDashboardDictionary().then(() => {
            const getDashboard = (id: number): void => {
                this.$scope.downloadedDashboard = false
                DataProvider.Dashboard.getDashboard(id).then((dashboard: DashboardModel) => {
                    if (dashboard != null) {
                        if (dashboard.type === Enums.DashboardType.DXDashboard || dashboard.type === Enums.DashboardType.DXDashboardMulti) {
                            this.$state.go('dxdashboard', { id: dashboard.idDashboard })
                        } else {
                            if (id != dashboard.idDashboard) {
                                if (dashboard.type === Enums.DashboardType.Standard) {
                                    this.$state.go('dashboard', { id: dashboard.idDashboard })
                                }
                            }
                            this.$scope.model = dashboard
                            this.$scope.originalModel = $.extend(true, {}, dashboard)

                            if (!this.$scope.model.files)
                                this.$scope.model.files = []

                            if (!this.$scope.model.descriptions)
                                this.$scope.model.descriptions = []

                            this.$scope.dashboardDescriptions = []
                            if (this.$scope.model.nameDescriptions)
                                this.$scope.dashboardDescriptions = [this.$scope.model.nameDescriptions]

                            this.$scope.descriptions = $.map(this.$scope.model.descriptions, (value, index) => {
                                return [value]
                            })

                            this.updateDashboardStyles(dashboard)
                            this.refreshDashboard()

                            this.$scope.gridsterItems = []

                            const interval: any = setInterval(() => {
                                if (this.getMainContentElement().height()) {
                                    clearInterval(interval)

                                    this.updateItems()
                                    this.initializeGridsterContainer()
                                    this.initializeGridster()

                                    this.dashboardMd5 = Md5.init(JSON.stringify(this.$scope.gridsterItems))
                                }
                            }, 500)
                        }
                    } else if (id != 0) {
                        getDashboard(0)
                    }
                }).done(() => {
                    this.$timeout(() => {
                        this.$scope.downloadedDashboard = true
                        this.$scope.isDashboardLoading = false

                        this.updateDashboardHeight(this.isDashboardMobileMode)
                        this.toggleGridsterMobileMode(this.isDashboardMobileMode)
                        this.toggleGridsterFitToScreenMode(this.$scope.model.fitToScreen)
                        this.toggleGridsterKeepAspectRationMode(this.$scope.model.keepAspectRatio)
                    })
                })
            }

            getDashboard(<number>id)
        })
    }

    private addNewItemToGridster = (item: DashboardColumnModel, isApplied: boolean = false) => {
        const gridsterItem: any = this.createGridsterItem(item.size, item.height)

        gridsterItem.items = item.items
        gridsterItem.size = item.size
        gridsterItem.originalSizeY = item.height
        gridsterItem.title = item.title
        gridsterItem.opState = item.opState
        gridsterItem.borderVisible = item.borderVisible
        gridsterItem.groupId = item.groupId
        gridsterItem.isTemplate = true
        gridsterItem.refreshPeriod = item.refreshPeriod
        gridsterItem.module = item.module
        gridsterItem.indexNbr = item.indexNbr
        gridsterItem.descr = item.descr
        gridsterItem.isApplied = isApplied

        this.$scope.gridsterItems.push(gridsterItem)

        this.onDashboardItemAdded()
    }


    // unused currently, made for disabling templates
    // 
    // refreshTemplateSelectAvailability(column) {
    //     this.templateRequestPromise.promise.then(() => {
    //         let item = _.find(this.$scope.dashboardTemplates[0].items, (template: any) => template.groupId == column.groupId)
    //         if (item)
    //             item.disabled = true
    //     })
    // }

    // resetTemplateSelectAvailability() {
    //     this.templateRequestPromise.promise.then(() => {
    //         this.$scope.dashboardTemplates[0].items.forEach(item => {
    //             item.disabled = false
    //         })
    //     })
    // }

    updateItems() {
        if (!this.$scope.model) return
        this.$scope.gridsterItems = []
        this.$scope.model.rows.forEach((row: DashboardRowModel, rowIndex: number) => {
            row.columns.forEach(column => {
                var refreshFunction = () => {
                    if (this.$scope.$root) {
                        this.$timeout(() => {
                            var originalItemsObject = jQuery.extend(true, {}, this.$scope.gridsterItems)
                            this.originalGridsterItems = $.map(originalItemsObject, value => {
                                return [value]
                            })
                        })

                        var req = new DashboardRequestModel();
                        req.groupId = column.groupId
                        req.ids = column.items.map(i => i.id)
                        req.idDashboard = this.$scope.model.idDashboard

                        let refreshGroup = (request) => {
                            if (this.$scope.$root) {
                                this.$scope.$root.$broadcast(EventsNames.DISABLE_LOADING_INDICATOR)
                                this.api.dashboard.getDashbordItems(request).then(r => {
                                    let grItem

                                    if (r) {
                                        r.result.forEach((obj: any) => {
                                            if (obj.series && obj.series.length) {
                                                obj.series.forEach((serie: DashboardChartSeries) => {
                                                    const types = this.types.filter(x => x.idDataTypeClass.toString() === serie.xTypeName)
                                                    if (types.length) {
                                                        serie.xTypeName = types[0].value
                                                        serie.xType = types[0].value
                                                    }
                                                })
                                            }
                                            let gridsterElement
                                            _.forEach(this.$scope.gridsterItems, gridsterItem => {
                                                _.forEach(gridsterItem.items, (it: any) => {
                                                    if (it.id == obj['id'] && !it['isProceeded'] && !obj['isProceeded'] && (!this.$scope.isEditMode || !it.data)) {
                                                        if (obj && obj.backgroundColor && obj.backgroundColor.indexOf('#') > -1)
                                                            obj.backgroundColor = this.hexToRgbA(obj.backgroundColor)
                                                        if (obj && obj.hoverColor && obj.hoverColor.indexOf('#') > -1)
                                                            obj.hoverColor = this.hexToRgbA(obj.hoverColor)
                                                        if (obj && obj.selectColor && obj.selectColor.indexOf('#') > -1)
                                                            obj.selectColor = this.hexToRgbA(obj.selectColor)
                                                        if (obj && obj.shadowColor && obj.shadowColor.indexOf('#') > -1)
                                                            obj.shadowColor = this.hexToRgbA(obj.shadowColor)
                                                        if (obj && obj.borderColor && obj.borderColor.indexOf('#') > -1)
                                                            obj.borderColor = this.hexToRgbA(obj.borderColor)
                                                        if (obj && obj.legendItems && obj.legendItems.length > 0)
                                                            obj.legendItems.forEach(legendItem => {
                                                                if (legendItem.color && legendItem.color.indexOf('#') > -1)
                                                                    legendItem.color = this.hexToRgbA(legendItem.color)
                                                            })

                                                        it.data = $.extend(true, {}, obj)
                                                        it['isProceeded'] = true
                                                        obj['isProceeded'] = true

                                                        if (it.data.amountVisible == true && it.data.value != null) {
                                                            if (it.data.isAmountADate == true) {
                                                                it.data.value = moment(it.data.value).format(window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
                                                            }
                                                        } else if (it.data.amountVisible == true && !it.data.value) {
                                                            it.data.value = 0
                                                        }
                                                        else if (it.data.amountVisible == true) it.data.amountVisible = false
                                                        grItem = gridsterItem
                                                    }
                                                    if (it.data) {
                                                        it.data.fontColor = it.fontColor
                                                    }
                                                })
                                            })
                                        })

                                        if (grItem && grItem.refreshPeriod && request.groupId == grItem.groupId && !this.$scope.isEditMode) {
                                            this.$timeout(() => {
                                                _.forEach(this.$scope.gridsterItems, gridsterItem => {
                                                    _.forEach(gridsterItem.items, (item: any) => {
                                                        item['isProceeded'] = false
                                                    })
                                                })
                                                refreshGroup(request)
                                            }, grItem.refreshPeriod)
                                        }

                                        if (grItem) {
                                            let originalItem = _.find(this.originalGridsterItems, it => it.groupId == request.groupId)
                                            originalItem.items = $.map($.extend(true, {}, grItem.items), val => [val])
                                            originalItem.items.forEach(item => {
                                                switch (item.type) {
                                                    case Enums.DashboardItemClass.MAP: {
                                                        if (item.data) {
                                                            const mapSource: MapSource = {
                                                                markers: item.data.markers,
                                                                polygons: item.data.polygons,
                                                                ranges: item.data.ranges
                                                            }
                                                            this.$scope.$broadcast(EventsNames.DASHBOARD_UPDATE_MAP_SOURCE + item.id, mapSource)
                                                        }
                                                        break;
                                                    }
                                                    case Enums.DashboardItemClass.GRID: {
                                                        if (item.data) {
                                                            this.$scope.$broadcast(EventsNames.DASHBOARD_UPDATE_TABLE_SOURCE + item.id, item.data.dataSource)
                                                        }
                                                        break;
                                                    }
                                                    case Enums.DashboardItemClass.CHART: {
                                                        this.$scope.$broadcast(EventsNames.DASHBOARD_UPDATE_CHART_SOURCE + item.id, item.data)
                                                        break;
                                                    }
                                                    case Enums.DashboardItemClass.GAUGE: {
                                                        if (item.data) {
                                                            this.$scope.$broadcast(EventsNames.DASHBOARD_UPDATE_METER_SOURCE + item.id, item.data.value)
                                                        }
                                                        break;
                                                    }
                                                    case Enums.DashboardItemClass.TILE: {
                                                        if (item.data) {
                                                            this.$scope.$broadcast(EventsNames.UPDATE_DASHBOARD_ITEM + item.id, item.data)
                                                        }
                                                        break;
                                                    }
                                                }
                                            })
                                        }

                                        if (!r.result.length) {
                                            this.$scope.$broadcast(EventsNames.DASHBOARD_UPDATE_MAP_SOURCE + req.ids[0], <MapSource>{
                                                markers: [],
                                                polygons: [],
                                                ranges: []
                                            })
                                        }
                                    }
                                }).finally(() => {
                                    if (this.$scope.$root) {
                                        this.$scope.$root.$broadcast(EventsNames.ENABLE_LOADING_INDICATOR)
                                    }
                                })
                            }
                        }

                        refreshGroup(req)
                    }
                }

                const gridsterItem = this.createGridsterItem(column.size, column.height)

                gridsterItem.col = column.column,
                    gridsterItem.row = undefined,
                    gridsterItem.items = column.items.map(item => _.clone(item)),
                    gridsterItem.size = column.size,
                    gridsterItem.originalSizeY = column.height,
                    gridsterItem.title = column.title,
                    gridsterItem.borderVisible = column.borderVisible,
                    gridsterItem.groupId = column.groupId,
                    gridsterItem.module = column.module,
                    gridsterItem.indexNbr = column.indexNbr,
                    gridsterItem.descr = column.descr,
                    gridsterItem.opState = column.opState,
                    gridsterItem.refreshPeriod = column.refreshPeriod

                this.$scope.gridsterItems.push(gridsterItem)
                this.originalGridsterItems.push(jQuery.extend(true, {}, gridsterItem))

                this.$timeout(() => {
                    refreshFunction()
                }, 0)
            })
        })
    }

    //#region Gridster Options

    getGroupGridsterOptions(column: DashboardColumnModel, groupHeight: number) {
        const rowHeight = this.$scope.checkRowCountInGroup(column)

        return <any>{
            columns: 12,
            rows: rowHeight,
            maxRows: rowHeight,
            rowHeight: groupHeight / rowHeight,
            mobileModeEnabled: false,
            swapping: true,
            resizable: {
                enabled: false
            },
            draggable: {
                enabled: true,
                handle: '.move-container-opacity'
            }
        }
    }

    //#endregion


    calculateElementWidthPxByColumns(width: number) {
        return Math.floor(100 * width / 12)
    }

    calculateWSGroupHeight(height: number) {
        var containerHeight
        if (this.$scope.model.keepAspectRatio && !this.$scope.model.fitToScreen)
            containerHeight = this.getDashboardElement().innerWidth()
        else
            containerHeight = angular.element('#mainContent').height()
        let h = Math.floor(height * (this.$scope.rowHeight as number) / containerHeight * 100)
        return h
    }

    calculateGroupIndex(dashboards: DashboardModel[]) {
        var index = Math.max(...dashboards.map(dashboard => dashboard.rows.map(row => row.columns.map(column => column.indexNbr))).join(',').split(',').map(c => +c))
        return index
    }

    calculateItemIndex(dashboards: DashboardModel[]) {
        var index = Math.max(...dashboards.map(dashboard => dashboard.rows.map(row => row.columns.map(column => column.items.map(item => item.indexNbr)))).join(',').split(',').map(c => +c))
        return index
    }

    calculateGroupId(dashboards: DashboardModel[], control, lastGroupsIds: number[]) {
        if (control.isTemplate || control.opState == OpChangeState.New) {
            let groupId = Math.max(...dashboards.map(dashboard => dashboard.rows.map(row => row.columns.map(column => column.groupId))).join(',').split(',').map(c => +c), ...lastGroupsIds)
            return groupId + 1
        }
        return control.groupId
    }

    //#region Dashboard State

    private getDashboardGroupState(control, index: number) {
        if (control.opState && control.opState != CommonHelper.ChangeState.Loaded)
            return control.opState

        if (control.isDeleted)
            return CommonHelper.ChangeState.Delete

        let group: DashboardColumnModel
        for (let i = 0; i < this.$scope.model.rows.length; i++) {
            var columns = this.$scope.model.rows[i].columns

            group = _.find(columns, col => col.groupId == control.groupId)

            if (group != null) {
                break
            }
        }

        if (!group) {
            return CommonHelper.ChangeState.New
        }

        if (group.size != control.sizeX || group.height != control.sizeY || group.indexNbr != index) {
            return CommonHelper.ChangeState.Modified
        }

        const groupId = control.groupId
        const gridsterItem = _.find(this.$scope.gridsterItems, gi => gi.groupId == groupId)
        const originalGridsterItem = _.find(this.originalGridsterItems, gi => gi.groupId == groupId)

        if (!gridsterItem || !originalGridsterItem || gridsterItem.col != originalGridsterItem.col || gridsterItem.row != originalGridsterItem.row) {
            return CommonHelper.ChangeState.Modified
        }

        return CommonHelper.ChangeState.Loaded
    }

    //#endregion


    private updateDashboardStyles(model) {
        this.$scope.dashboardStyle = {}
        if (model.maxWidth) {
            this.$scope.dashboardStyle['max-width'] = model.maxWidth
            this.$scope.dashboardStyle['margin-left'] = 'auto'
            this.$scope.dashboardStyle['margin-right'] = 'auto'
        }
        if (model.width) {
            this.$scope.dashboardStyle['width'] = model.width
            this.$scope.dashboardStyle['margin-left'] = 'auto'
            this.$scope.dashboardStyle['margin-right'] = 'auto'
        }

        if (model.maxHeight) {
            this.$scope.dashboardStyle['max-height'] = model.maxHeight
        }

        const mainContent = angular.element('#mainContent')

        this.$scope.dashboardStyle['background-color'] = model.backgroundColor
        mainContent.css('background-color', model.backgroundColor)
    }

    createFormDataForElement(element) {
        this.$scope.isEditPopupLoading = true

        let promises = []

        let activeViews = this.localDictionary.getActiveViews()

        let activeViewsArray = $.map(activeViews, view => [view])
        this.activeViews = activeViewsArray.map(activeView => {
            let column = _.find(activeView.columns, (column: any) => !column.idKeyViewColumn)

            let referenceTypeName;
            for (let key in ReferenceType) {
                if ((ReferenceType[key] as any as number) == activeView.idReferenceType)
                    referenceTypeName = key
            }

            return {
                idReferenceType: activeView.idReferenceType,
                caption: referenceTypeName ? referenceTypeName : activeView.toString(),
                idDataType: column ? column.idDataType : 0
            }
        })

        if (element.type == 3) {
            element.data.columns.forEach(column => {
                if (column.type == "System.Int32") column.type = "System.Int64"
            })
        } else if (element.type == 2) {
            element.data.series.forEach(serie => {
                if (serie.xType == "System.Int32") {
                    serie.xType = "System.Int64"
                    serie.xName = "System.Int64"
                }
                if (serie.yType == "System.Int32") {
                    serie.yType = "System.Int64"
                    serie.yName = "System.Int64"
                }
            })
        }

        let formData = element.data
        let formItems = []
        let group: { itemType: string, caption: string, colCount: number, items: DevExpress.ui.dxFormSimpleItem[], itemsAfterCommon: any[] } = {
            itemType: 'group',
            caption: i18n('Popup', 'CommonSettings'),
            colCount: 1,
            items: [<DevExpress.ui.dxFormSimpleItem>{
                dataField: 'type',
                label: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ControlName)
                },
                template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.type' : 'newItem.data.type') + '" element-id="' + element.data.id + '" descriptions="' + (this.$scope.editedItem ? '[editedItem.data.type]' : '[]') + '" property-name="data.type" type="' + DescrType.ItemField + '" callback="onDescrSelectionChanged"></select-add-descr>'
            }],
            itemsAfterCommon: []
        }
        formItems.push(group)

        if (element.isCustomizable) {
            switch (element.type) {
                case CommonHelper.DashboardItemType.Tile: {
                    group.items.push(...[
                        <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'textHeader.description',
                            label: {
                                text: i18n('Popup', 'TextHeader')
                            },
                            template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.textHeader' : 'newItem.data.textHeader') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.textHeader" type="' + DescrType.ItemField + '" callback="onDescrSelectionChanged"></select-add-descr>'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'titlePosition',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TitlePosition)
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.positionList,
                                displayExpr: 'value',
                                valueExpr: 'id'
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'titleSize',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TitleSize) + ', px'
                            },
                            editorType: 'dxNumberBox'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'texHeaderVisible',
                            label: {
                                text: i18n('Popup', 'TextHeaderVisible')
                            },
                            editorType: 'dxCheckBox',
                            editorOptions: {
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'titleColor',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TitleColor),
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: "instantly"
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'amountVisible',
                            label: {
                                text: i18n('Popup', 'TileAmountVisible')
                            },
                            editorType: 'dxCheckBox',
                            editorOptions: {

                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'valuePosition',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValuePosition),
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.positionList,
                                displayExpr: 'value',
                                valueExpr: 'id'
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'valueSize',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValueSize) + ', px'
                            },
                            editorType: 'dxNumberBox'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'valueColor',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValueColor),
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: "instantly"
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'referenceType',
                            label: {
                                text: i18n('Popup', 'ReferenceType')
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.activeViews,
                                displayExpr: 'caption',
                                valueExpr: 'idReferenceType',
                                showClearButton: true
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'correlationType',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CorrelationType)
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.correlationType.filter(type => type.id != CorrelationType.Server),
                                displayExpr: 'value',
                                valueExpr: 'id',
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'backgroundColor',
                            label: {
                                text: i18n('Popup', 'TileBackgroundColor')
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: 'instantly',
                                editAlphaChannel: true
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'backgroundImageId',
                            label: {
                                text: i18n('Popup', 'TileBackgroundImage')
                            },
                            template: '<select-add-file current-id="' + (element.data.backgroundImage ? element.data.backgroundImage.id : -1) + '" element-id="' + element.data.id + '" index-nbr="0" property-name="backgroundImage" files="model.files" callback="onFileSelectionChanged"></select-add-file>'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'hoverColor',
                            label: {
                                text: i18n('Popup', 'TileHoverColor')
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: 'instantly',
                                editAlphaChannel: true
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'selectColor',
                            label: {
                                text: i18n('Popup', 'TileSelectColor')
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: 'instantly',
                                editAlphaChannel: true
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'iconId',
                            label: {
                                text: i18n('Popup', 'TileIcon')
                            },
                            template: '<select-add-file current-id="' + (element.data.icon ? element.data.icon.id : -1) + '" element-id="' + element.data.id + '" index-nbr="1" property-name="icon" files="model.files" callback="onFileSelectionChanged"></select-add-file>'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'iconVisible',
                            label: {
                                text: i18n('Popup', 'TileIconVisible')
                            },
                            editorType: 'dxCheckBox'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'iconPosition',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IconPosition),
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.positionList,
                                displayExpr: 'value',
                                valueExpr: 'id'
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'iconStretch',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IconStretch)
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.iconStretch,
                                displayExpr: 'value',
                                valueExpr: 'id',
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Structure)
                            },
                            template: '<div dx-button="editElementButtonOptions"></div>'
                        }
                    ])

                    formItems.push({
                        itemType: 'group',
                        caption: i18n('Popup', 'Border'),
                        colCount: 1,
                        items: [
                            {
                                dataField: 'borderColor',
                                label: {
                                    text: i18n('Popup', 'BorderColor')
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: 'instantly',
                                    editAlphaChannel: true
                                }
                            },
                            {
                                dataField: 'borderWidth',
                                label: {
                                    text: i18n('Popup', 'BorderWidth')
                                },
                                editorType: 'dxNumberBox'
                            },
                            {
                                dataField: 'borderRadius[0]',
                                label: {
                                    text: i18n('Popup', 'RadiusTopLeft')
                                },
                                editorType: 'dxNumberBox',
                                editorOptions: {
                                    min: 0,
                                    mode: 'number',
                                    onChange: (e: any) => {
                                        const value = e.component.option('value')
                                        if ([undefined, null].indexOf(value) >= 0 || value.length === 0) {
                                            e.component.option('value', 0)
                                        }
                                    }
                                }
                            },
                            {
                                dataField: 'borderRadius[1]',
                                label: {
                                    text: i18n('Popup', 'RadiusTopRight')
                                },
                                editorType: 'dxNumberBox',
                                editorOptions: {
                                    min: 0,
                                    mode: 'number',
                                    onChange: (e: any) => {
                                        const value = e.component.option('value')
                                        if ([undefined, null].indexOf(value) >= 0 || value.length === 0) {
                                            e.component.option('value', 0)
                                        }
                                    }
                                }
                            },
                            {
                                dataField: 'borderRadius[2]',
                                label: {
                                    text: i18n('Popup', 'RadiusBottomRight')
                                },
                                editorType: 'dxNumberBox',
                                editorOptions: {
                                    min: 0,
                                    mode: 'number',
                                    onChange: (e: any) => {
                                        const value = e.component.option('value')
                                        if ([undefined, null].indexOf(value) >= 0 || value.length === 0) {
                                            e.component.option('value', 0)
                                        }
                                    }
                                }
                            },
                            {
                                dataField: 'borderRadius[3]',
                                label: {
                                    text: i18n('Popup', 'RadiusBottomLeft')
                                },
                                editorType: 'dxNumberBox',
                                editorOptions: {
                                    min: 0,
                                    mode: 'number',
                                    onChange: (e: any) => {
                                        const value = e.component.option('value')
                                        if ([undefined, null].indexOf(value) >= 0 || value.length === 0) {
                                            e.component.option('value', 0)
                                        }
                                    }
                                }
                            }
                        ]
                    })

                    formItems.push({
                        itemType: 'group',
                        caption: i18n('Popup', 'BoxShadow'),
                        colCount: 1,
                        items: [
                            {
                                dataField: 'shadowColor',
                                label: {
                                    text: i18n('Popup', 'ShadowColor')
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: 'instantly',
                                    editAlphaChannel: true
                                }
                            },
                            {
                                dataField: 'shadowHorizontalLenght',
                                label: {
                                    text: i18n('Popup', 'ShadowHorizontalLength')
                                },
                                editorType: 'dxNumberBox'
                            },
                            {
                                dataField: 'shadowVerticalLenght',
                                label: {
                                    text: i18n('Popup', 'ShadowVerticalLength')
                                },
                                editorType: 'dxNumberBox'
                            },
                            {
                                dataField: 'shadowSpreadRadius',
                                label: {
                                    text: i18n('Popup', 'ShadowSpreadRadius')
                                },
                                editorType: 'dxNumberBox'
                            },
                            {
                                dataField: 'shadowBlurRadius',
                                label: {
                                    text: i18n('Popup', 'ShadowBlurRadius')
                                },
                                editorType: 'dxNumberBox'
                            }
                        ]
                    })
                    break
                }
                case CommonHelper.DashboardItemType.Gauge: {
                    const dashboardGaugeDataModel: DashboardGaugeDataModel = this.$scope.newItem ? this.$scope.newItem.data as DashboardGaugeDataModel : null
                    const dashboardGaugeDataModelEdit: DashboardGaugeDataModel = this.$scope.editedItem ? this.$scope.editedItem.data as DashboardGaugeDataModel : null
                    group.items.push(...[
                        <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'label.description',
                            label: {
                                text: i18n('Common', 'Label')
                            },
                            isRequired: true,
                            template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.label' : 'newItem.data.label') + '" element-id="' + element.id + '" descriptions="descriptions" property-name="data.label" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'min',
                            label: {
                                text: i18n('Popup', 'MinValue')
                            },
                            editorType: 'dxNumberBox',
                            validationRules: [{
                                type: 'required',
                                message: i18n('Common', 'RequiredField')
                            }]
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'max',
                            label: {
                                text: i18n('Popup', 'MaxValue')
                            },
                            editorType: 'dxNumberBox',
                            editorOptions: {
                                min: dashboardGaugeDataModelEdit ? dashboardGaugeDataModelEdit.min : dashboardGaugeDataModel.min
                            },
                            validationRules: [{
                                type: 'required',
                                message: i18n('Common', 'RequiredField')
                            }]
                        }
                    ])

                    if (element.data.ranges) {
                        let minNumberBoxes = {}
                        let maxNumberBoxes = {}

                        element.data.ranges.forEach((range, index) => {
                            formItems.push({
                                itemType: 'group',
                                caption: i18n('Popup', 'Range') + ' ' + (index + 1),
                                colCount: 1,
                                items: [
                                    {
                                        label: {
                                            visible: false
                                        },
                                        template: '<form-button options="{ type: \'DELETE\', buttonHint: \'' + i18n('Popup', 'DeleteRange') + '\', elementId: ' + element.id + ', propertyName: \'ranges\', index: ' + index + '}" callback="onFormButtonClicked"></form-button>'
                                    },
                                    {
                                        dataField: 'ranges[' + index + '].name',
                                        label: {
                                            text: i18n('Popup', 'Name')
                                        },
                                        isRequired: true,
                                        template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.ranges[' + index + '].name' : 'newItem.data.ranges[' + index + '].name') + '" element-id="' + element.id + '" descriptions="descriptions" property-name="data.ranges.' + index + '.name" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                                    },
                                    {
                                        dataField: 'ranges[' + index + '].minValue',
                                        label: {
                                            text: i18n('Popup', 'MinValue')
                                        },
                                        editorType: 'dxNumberBox',
                                        editorOptions: {
                                            onInitialized: (e: any) => {
                                                minNumberBoxes[index] = e.component
                                                minNumberBoxes[index].option('onValueChanged', (e: any) => {
                                                    if (e.value) {
                                                        if (maxNumberBoxes[index]) {
                                                            maxNumberBoxes[index].option('min', e.value)
                                                        }
                                                    }
                                                    else {
                                                        if (maxNumberBoxes[index]) {
                                                            maxNumberBoxes[index].option('min', 0)
                                                        }
                                                    }
                                                    this.updateDashboardItems(element.id)
                                                })
                                            }
                                        },
                                        validationRules: [{
                                            type: 'required',
                                            message: i18n('Common', 'RequiredField')
                                        }]
                                    },
                                    {
                                        dataField: 'ranges[' + index + '].maxValue',
                                        label: {
                                            text: i18n('Popup', 'MaxValue')
                                        },
                                        editorType: 'dxNumberBox',
                                        editorOptions: {
                                            min: dashboardGaugeDataModelEdit ? dashboardGaugeDataModelEdit.ranges[index].minValue : dashboardGaugeDataModel.ranges[index].minValue,
                                            onInitialized: (e: any) => {
                                                maxNumberBoxes[index] = e.component
                                            }
                                        },
                                        validationRules: [{
                                            type: 'required',
                                            message: i18n('Common', 'RequiredField')
                                        }]
                                    },
                                    {
                                        dataField: 'ranges[' + index + '].color',
                                        label: {
                                            text: i18n('Popup', 'Color')
                                        },
                                        editorType: 'dxColorBox',
                                        editorOptions: {
                                            applyValueMode: 'instantly',
                                            editAlphaChannel: true
                                        }
                                    }
                                ]
                            })
                        })
                    }

                    formItems.push({
                        itemType: 'simple',
                        label: {
                            visible: false
                        },
                        template: '<form-button options="{ type: \'ADD\', buttonHint: \'' + i18n('Popup', 'AddRange') + '\', elementId: ' + element.id + ', propertyName: \'ranges\'}" callback="onFormButtonClicked"></form-button>'
                    })
                    break
                }
                case CommonHelper.DashboardItemType.Card: {
                    const cardOptions = [
                        {
                            caption: i18n('Popup', 'Unknown'),
                            id: 0
                        }, {
                            caption: i18n('Popup', 'Keeper'),
                            id: 1
                        }, {
                            caption: i18n('Popup', 'Configuration'),
                            id: 2
                        }]

                    group.items.push(...[
                        <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'option',
                            label: {
                                text: i18n('Popup', 'Option')
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: cardOptions,
                                displayExpr: 'caption',
                                valueExpr: 'id',
                                onSelectionChanged: (e) => {
                                    if (e.selectedItem)
                                        this.$timeout(() => {
                                            this.editGroupForm.element().find(".cardReferenceValue").css("display", e.selectedItem.id != 1 ? "flex" : "none")
                                            formData['referenceValue'] = 0
                                            formData['header'] = ''
                                        })
                                }
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'referenceValue',
                            label: {
                                text: i18n('Popup', 'ReferenceObject')
                            },
                            cssClass: 'cardReferenceValue',
                            isRequired: true,
                            template: '<select-popover selected-id="' + element.data.referenceValue + '" datatype-id="' + CommonHelper.userColumnId + '" options="{ referenceTypeId: ' + Enums.ReferenceType.IdOperator + '}" script-arg="data.referenceValue" callback="::onReferenceObjectChanged"></select-popover>'
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'backgroundColor',
                            label: {
                                text: i18n('Popup', 'TileBackgroundColor')
                            },
                            editorType: 'dxColorBox',
                            editorOptions: {
                                applyValueMode: 'instantly',
                                editAlphaChannel: true
                            }
                        }
                    ])
                    break
                }
                case CommonHelper.DashboardItemType.Chart: {
                    let defered = this.$q.defer()
                    promises.push(defered.promise)

                    this.localDictionary.getReferenceTable(CommonHelper.IdDataType, null).then(result => {
                        if (!element.data.series || element.data.series.length == 0) {
                            element.data.series = []
                            element.data.series.push(<DashboardChartSeries>{})
                        }
                        group.items.push(...[
                            <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'chartTitle.description',
                                label: {
                                    text: i18n('Popup', 'Title')
                                },
                                template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.chartTitle' : 'newItem.data.chartTitle') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.chartTitle" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'titlePosition',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TitlePosition)
                                },
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                    dataSource: this.positionList.filter(x => x.id === Enums.Alignment.Unknown || x.id === Enums.Alignment.Center || x.id === Enums.Alignment.Left || x.id === Enums.Alignment.Right),
                                    displayExpr: 'value',
                                    valueExpr: 'id'
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'titleColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TitleColor)
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.titleColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'series[0].xCaption',
                                label: {
                                    text: i18n('Popup', 'xCaption')
                                },
                                isRequired: true,
                                template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.series[0].xCaption' : 'newItem.data.series[0].xCaption') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.series.0.xCaption" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'axisXColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AxisXColor)
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.axisXColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isXAxisTitleHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsXAxisTitleHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'series[0].yCaption',
                                label: {
                                    text: i18n('Popup', 'yCaption')
                                },
                                isRequired: true,
                                template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.series[0].yCaption' : 'newItem.data.series[0].yCaption') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.series.0.yCaption" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'axisYColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AxisYColor)
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.axisYColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isYAxisTitleHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsYAxisTitleHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'series[0].xIdDataTypeFormat',
                                label: {
                                    text: i18n('Popup', 'xFormatDataType')
                                },
                                cssClass: 'xIdDataTypeFormat',
                                template: '<select-popover selected-id="' + element.data.series[0].xIdDataTypeFormat + '" datatype-id="null" options="{ referenceTypeId: ' + Enums.ReferenceType.IdDataType + '}" script-arg="data.series.0.xIdDataTypeFormat" callback="::onDataTypeChanged" source="{dictionaryMethod: \'getDataTypeColumns\'}"></select-popover>'
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'series[0].xTypeName',
                                label: {
                                    text: i18n('Popup', 'xType')
                                },
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                    dataSource: this.types,
                                    displayExpr: 'caption',
                                    valueExpr: 'value',
                                    onInitialized: (e: any) => {
                                        this.$scope['xTypeNameSelectBox'] = e.component

                                        if (element.data.series[0] && element.data.series[0].xIdDataTypeFormat) {
                                            this.$scope['xTypeNameSelectBox'].option('disabled', true)
                                        }
                                    }
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'series[0].yIdDataTypeFormat',
                                label: {
                                    text: i18n('Popup', 'yFormatDataType')
                                },
                                template: '<select-popover selected-id="' + element.data.series[0].yIdDataTypeFormat + '" datatype-id="null" options="{ referenceTypeId: ' + Enums.ReferenceType.IdDataType + '}" script-arg="data.series.0.yIdDataTypeFormat" callback="::onDataTypeChanged" source="{dictionaryMethod: \'getDataTypeColumns\'}"></select-popover>'
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'series[0].yTypeName',
                                label: {
                                    text: i18n('Popup', 'yType')
                                },
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                    dataSource: this.types,
                                    displayExpr: 'caption',
                                    valueExpr: 'value',
                                    onInitialized: (e: any) => {
                                        this.$scope['yTypeNameSelectBox'] = e.component

                                        if (element.data.series[0] && element.data.series[0].yIdDataTypeFormat) {
                                            this.$scope['yTypeNameSelectBox'].option('disabled', true)
                                        }
                                    }
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'correlationType',
                                label: {
                                    text: i18n('Popup', 'CorrelationType')
                                },
                                editorType: 'dxSelectBox',
                                editorOptions: {
                                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                    dataSource: this.correlationType,
                                    displayExpr: 'value',
                                    valueExpr: 'id',
                                    onSelectionChanged: (e: any) => {
                                        this.$timeout(() => {
                                            this.editGroupForm.element().find(".script").css("display", e.selectedItem.id != CorrelationType.Server ? "flex" : "none")
                                            this.editGroupForm.element().find(".xIdDataTypeFormat").css("display", e.selectedItem.id != CorrelationType.Server ? "flex" : "none")
                                            this.editGroupForm.element().find(".hideIfServer").css("display", e.selectedItem.id != CorrelationType.Server ? "flex" : "none")
                                            this.editGroupForm.element().find(".hideIfServerBlock").css("display", e.selectedItem.id != CorrelationType.Server ? "block" : "none")

                                            if (e.selectedItem.id == CorrelationType.Server) {
                                                formData.series[0].seriesCaption = { idDescr: 0, description: ' ', idLanguage: 0, opState: 0, allLanguagesDescription: [] }
                                                formData.series[0].seriesType = ChartType.Line

                                                formItems.forEach(item => {
                                                    if (item.itemType == 'group' && item.caption && item.caption.includes(i18n('Popup', 'Serie') + ' ')) {
                                                        item['oldCaption'] = item.caption
                                                        item.caption = null
                                                    }
                                                })
                                            }
                                        })
                                    }
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'fontColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FontColor),
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.fontColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'backgroundColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BackgroundColor),
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'axisGridColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AxisGridColor)
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.axisGridColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isHorizontalGridHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsHorizontalGridHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isVerticalGridHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsVerticalGridHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'tooltipBackgroundColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TooltipBackgroundColor)
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.tooltipBackgroundColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'tooltipValueColor',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TooltipValueColor)
                                },
                                editorType: 'dxColorBox',
                                editorOptions: {
                                    applyValueMode: "instantly",
                                    onValueChanged: (e: any) => {
                                        element.tooltipValueColor = e.value
                                    },
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isLegendButtonHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsLegendButtonHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isLegendValueVisible',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsLegendValueVisible)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isFullscreenButtonHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsFullscreenButtonHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isSeriesLabelVisible',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsSeriesLabelVisible)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'isTooltipHidden',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IsTooltipHidden)
                                },
                                editorType: 'dxCheckBox',
                                editorOptions: {
                                }
                            }, <DevExpress.ui.dxFormSimpleItem>{
                                dataField: 'startupSerie',
                                label: {
                                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.StartupSerie)
                                },
                                editorType: 'dxSelectBox',
                                editorOptions: <DevExpress.ui.dxSelectBoxOptions>{
                                    noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                    placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                    dataSource: (<DashboardChartSeries[]>element.data.series).filter(x => !!x.seriesName),
                                    displayExpr: 'seriesName',
                                    valueExpr: 'seriesName',
                                    showClearButton: true,
                                    onInitialized: (e) => {
                                        this.startupSerieSelectBox = e.component
                                    }
                                }
                            }
                        ])

                        const chartTypes = []
                        for (let key in ChartType) {
                            chartTypes.push({
                                caption: key,
                                value: ChartType[key]
                            })
                        }

                        if (element.data.series) {
                            element.data.series.forEach((serie: DashboardChartSeries, index) => {
                                if (element.data.correlationType != CorrelationType.Server || element.data.correlationType == CorrelationType.Server && index < 1) {
                                    const seriesItems = []
                                    seriesItems.push({
                                        label: {
                                            visible: false
                                        },
                                        cssClass: 'hideIfServerBlock',
                                        template: '<form-button options="{ type: \'DELETE\', buttonHint: \'' + i18n('Popup', 'DeleteSerie') + '\', elementId: ' + element.id + ', propertyName: \'series\', index: ' + index + '}" callback="onFormButtonClicked"></form-button>'
                                    })

                                    if (this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_ITEM_CONFIGURATION))
                                        seriesItems.push({
                                            dataField: 'series[' + index + '].seriesName',
                                            label: {
                                                text: i18n('Popup', 'Name')
                                            },
                                            isRequired: true,
                                            cssClass: 'hideIfServer',
                                            editorType: 'dxTextBox',
                                            editorOptions: <DevExpress.ui.dxTextBoxOptions>{
                                                onValueChanged: (e: any) => {
                                                    if (this.startupSerieSelectBox) {
                                                        this.startupSerieSelectBox.option({ dataSource: (<DashboardChartSeries[]>element.data.series).filter(x => !!x.seriesName) })
                                                    }
                                                }
                                            }
                                        })

                                    seriesItems.push(
                                        {
                                            dataField: 'series[' + index + '].seriesCaption',
                                            label: {
                                                text: i18n('Popup', 'Caption')
                                            },
                                            isRequired: true,
                                            cssClass: 'hideIfServer',
                                            template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.series[' + index + '].seriesCaption' : 'newItem.data.series[' + index + '].seriesCaption') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.series.' + index + '.seriesCaption" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                                        },
                                        {
                                            dataField: 'series[' + index + '].seriesColor',
                                            label: {
                                                text: i18n('Popup', 'Color')
                                            },
                                            editorType: 'dxColorBox',
                                            cssClass: 'hideIfServer',
                                            editorOptions: {
                                                applyValueMode: 'instantly',
                                                editAlphaChannel: true
                                            }
                                        },
                                        {
                                            dataField: 'series[' + index + '].seriesType',
                                            label: {
                                                text: i18n('Popup', 'ChartType')
                                            },
                                            editorType: 'dxSelectBox',
                                            cssClass: 'hideIfServer',
                                            editorOptions: {
                                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                                dataSource: chartTypes,
                                                displayExpr: val => {
                                                    if (!val) return ''
                                                    return i18n('Popup', val.caption)
                                                },
                                                valueExpr: 'value'
                                            },
                                            validationRules: [{
                                                type: 'required',
                                                message: i18n('Common', 'RequiredField')
                                            }]
                                        },
                                        {
                                            dataField: 'series[' + index + '].referenceType',
                                            label: {
                                                text: i18n('Popup', 'ReferenceType')
                                            },
                                            editorType: 'dxSelectBox',
                                            editorOptions: {
                                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                                dataSource: this.activeViews,
                                                displayExpr: 'caption',
                                                valueExpr: 'idReferenceType',
                                                showClearButton: true
                                            }
                                        }
                                    )
                                    group.itemsAfterCommon.push({
                                        itemType: 'group',
                                        caption: element.data.correlationType != CorrelationType.Server ? i18n('Popup', 'Serie') + ' ' + (index + 1) : null,
                                        colCount: 1,
                                        items: seriesItems
                                    })
                                }
                            })
                        }

                        group.itemsAfterCommon.push({
                            itemType: 'simple',
                            label: {
                                visible: false
                            },
                            cssClass: 'hideIfServerBlock',
                            template: '<form-button options="{ type: \'ADD\', buttonHint: \'' + i18n('Popup', 'AddSerie') + '\', elementId: ' + element.id + ', propertyName: \'series\'}" callback="onFormButtonClicked"></form-button>'
                        })
                    }).finally(() => {
                        defered.resolve()
                    })
                    break
                }
                case CommonHelper.DashboardItemType.Grid: {
                    var locationProblemConfirmationPermission: boolean = this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_PROBLEM_CONFIRMATION_OP)
                    var locationPlanDeliveryPermission: boolean = this.userSession.getLoggedOperator().hasPermission(Activity.LOCATION_PLAN_DELIVERY_TIME_OP)
                    const buttonTypes = []

                    buttonTypes.push({
                        caption: 'Export',
                        option: Buttons.Export
                    })
                    buttonTypes.push({
                        caption: 'ColumnChooser',
                        option: Buttons.ColumnChooser
                    })
                    if (locationProblemConfirmationPermission)
                        buttonTypes.push({
                            caption: 'ProblemConfirmation',
                            option: Buttons.ProblemConfirmation
                        })
                    if (locationPlanDeliveryPermission)
                        buttonTypes.push({
                            caption: 'PlanDelivery',
                            option: Buttons.PlanDelivery
                        })

                    group.items.push(<DevExpress.ui.dxFormSimpleItem>{
                        dataField: 'referenceType',
                        label: {
                            text: i18n('Popup', 'ReferenceType')
                        },
                        editorType: 'dxSelectBox',
                        editorOptions: {
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                            dataSource: this.activeViews,
                            displayExpr: 'caption',
                            valueExpr: 'idReferenceType',
                            showClearButton: true
                        }
                    })
                    group.items.push(<DevExpress.ui.dxFormSimpleItem>{
                        dataField: 'options',
                        label: {
                            text: i18n('Popup', 'Options')
                        },
                        editorType: 'dxTagBox',
                        editorOptions: {
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                            dataSource: buttonTypes,
                            hideSelectedItems: true,
                            displayExpr: val => {
                                return i18n('Popup', val && val.caption ? val.caption : '')
                            },
                            valueExpr: 'option',
                            onSelectionChanged: (e: any) => {
                                e.addedItems.forEach(aItem => {
                                    const found = _.find(element.data.buttonOptions, (opt: any) => opt.option === aItem.option)
                                    found ? found.visible = true : element.data.buttonOptions.push((<any>Object).assign(_.clone(aItem), { visible: true }))
                                })

                                e.removedItems.forEach(rItem => {
                                    const found = _.find(element.data.buttonOptions, (opt: any) => opt.option === rItem.option)
                                    found ? found.visible = false : element.data.buttonOptions.push((<any>Object).assign(_.clone(rItem), { visible: false }))
                                })
                            }
                        }
                    })
                    group.items.push(<DevExpress.ui.dxFormSimpleItem>{
                        dataField: 'headerTextAlign',
                        label: {
                            text: i18n('Popup', 'HeaderTextAlign')
                        },
                        editorType: 'dxSelectBox',
                        editorOptions: {
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                            dataSource: this.textAlign,
                            displayExpr: 'value',
                            valueExpr: 'id'
                        }
                    })
                    group.items.push(<DevExpress.ui.dxFormSimpleItem>{
                        dataField: 'contextMenuEnabled',
                        label: {
                            text: i18n('Popup', 'ContextMenu')
                        },
                        editorType: 'dxCheckBox'
                    })
                    group.items.push(<DevExpress.ui.dxFormSimpleItem>{
                        dataField: 'shortDetailsEnabled',
                        label: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowChart)
                        },
                        editorType: 'dxCheckBox'
                    })
                    group.items.push(<DevExpress.ui.dxFormSimpleItem>{
                        dataField: 'correlationType',
                        label: {
                            text: i18n('Popup', 'CorrelationType')
                        },
                        editorType: 'dxSelectBox',
                        editorOptions: {
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                            dataSource: this.correlationType.filter(type => type.id != CorrelationType.Server),
                            displayExpr: 'value',
                            valueExpr: 'id'
                        }
                    })

                    if (element.data.columns) {
                        element.data.columns.forEach((item, index) => {
                            group.itemsAfterCommon.push({
                                itemType: 'group',
                                caption: i18n('Popup', 'Column') + ' ' + (index + 1),
                                colCount: 1,
                                items: [
                                    {
                                        label: {
                                            visible: false
                                        },
                                        template: '<form-button options="{ type: \'DELETE\', buttonHint: \'' + i18n('Popup', 'DeleteColumn') + '\', elementId: ' + element.id + ', propertyName: \'columns\', index: ' + index + '}" callback="onFormButtonClicked"></form-button>'
                                    },
                                    {
                                        dataField: 'columns[' + index + '].caption',
                                        label: {
                                            text: i18n('Popup', 'Caption')
                                        },
                                        isRequired: true,
                                        template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.columns[' + index + '].caption' : 'newItem.data.columns[' + index + '].caption') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.columns.' + index + '.caption" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                                    },
                                    {
                                        dataField: 'columns[' + index + '].type',
                                        label: {
                                            text: i18n('Popup', 'Type')
                                        },
                                        editorType: 'dxSelectBox',
                                        isRequired: true,
                                        editorOptions: {
                                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                            dataSource: this.types,
                                            displayExpr: 'caption',
                                            valueExpr: 'value'
                                        },
                                        validationRules: [{
                                            type: 'required',
                                            message: i18n('Common', 'RequiredField')
                                        }]
                                    },
                                    {
                                        dataField: 'idDataTypeFormat',
                                        label: {
                                            text: i18n('Popup', 'DataType')
                                        },
                                        template: '<select-popover selected-id="' + item.idDataTypeFormat + '" datatype-id="null" options="{ referenceTypeId: ' + Enums.ReferenceType.IdDataType + '}" script-arg="data.columns.' + index + '.idDataTypeFormat" callback="::onGridColumnDataTypeChanged" source="{dictionaryMethod: \'getDataTypeColumns\'}"></select-popover>'
                                    },
                                    {
                                        dataField: 'columns[' + index + '].tooltip',
                                        label: {
                                            text: i18n('Popup', 'Tooltip')
                                        },
                                        template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.columns[' + index + '].tooltip' : 'newItem.data.columns[' + index + '].tooltip') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.columns.' + index + '.tooltip" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                                    },
                                ]
                            })
                        })
                    }

                    group.itemsAfterCommon.push({
                        itemType: 'simple',
                        label: {
                            visible: false
                        },
                        template: '<form-button options="{ type: \'ADD\', buttonHint: \'' + i18n('Popup', 'AddColumn') + '\', elementId: ' + element.id + ', propertyName: \'columns\'}" callback="onFormButtonClicked"></form-button>'
                    })

                    if (!element.data.headerTextAlign) element.data.headerTextAlign = 0
                    if (!element.data.buttonOptions)
                        element.data.buttonOptions = []
                    formData['options'] = element.data.buttonOptions.filter((opt: any) => opt.visible).map(item => { return item.option }).filter(item => {
                        if (item != Buttons.ProblemConfirmation && item != Buttons.PlanDelivery) return true
                        else if (item == Buttons.ProblemConfirmation && locationProblemConfirmationPermission) return true
                        else if (item == Buttons.PlanDelivery && locationPlanDeliveryPermission) return true
                        else return false
                    })
                    break
                }
                case CommonHelper.DashboardItemType.Map: {
                    group.items.push(...[
                        <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'referenceType',
                            label: {
                                text: i18n('Popup', 'ReferenceType')
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.activeViews,
                                displayExpr: 'caption',
                                valueExpr: 'idReferenceType',
                                showClearButton: true
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'correlationType',
                            label: {
                                text: i18n('Popup', 'CorrelationType')
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.correlationType.filter(type => type.id != CorrelationType.Server),
                                displayExpr: 'value',
                                valueExpr: 'id',
                            }
                        }, <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'interaction',
                            label: {
                                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Interaction)
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: [{
                                    value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MarkerBounce), id: Enums.MapInteractionType.MarkerBounce
                                }, {
                                    value: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MarkerFilter), id: Enums.MapInteractionType.MarkerFilter
                                }],
                                displayExpr: 'value',
                                valueExpr: 'id',
                            }
                        }
                    ])

                    if (element.data.legendItems) {
                        element.data.legendItems.forEach((item, index) => {
                            formItems.push({
                                itemType: 'group',
                                caption: i18n('Popup', 'LegendItem') + ' ' + (index + 1),
                                colCount: 1,
                                items: [
                                    {
                                        label: {
                                            visible: false
                                        },
                                        template: '<form-button options="{ type: \'DELETE\', buttonHint: \'' + i18n('Popup', 'DeleteItem') + '\', elementId: ' + element.id + ', propertyName: \'legendItems\', index: ' + index + '}" callback="onFormButtonClicked"></form-button>'
                                    },
                                    {
                                        dataField: 'legendItems[' + index + '].description',
                                        label: {
                                            text: i18n('Popup', 'Description')
                                        },
                                        isRequired: true,
                                        template: '<select-add-descr current="' + (this.$scope.editedItem ? 'editedItem.data.legendItems[' + index + '].description' : 'newItem.data.legendItems[' + index + '].description') + '" element-id="' + element.data.id + '" descriptions="descriptions" property-name="data.legendItems.' + index + '.description" type="' + DescrType.ItemField + '" callback="::onDescrSelectionChanged"></select-add-descr>'
                                    }, {
                                        dataField: 'legendItems[' + index + '].iconId',
                                        label: {
                                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Icon)
                                        },
                                        template: '<select-add-file current-id="' + (element.data.legendItems[index].iconId ? element.data.legendItems[index].iconId : -1) + '" element-id="' + element.data.legendItems[index].iconId + '" index-nbr="0" property-name="legendItems.' + index + '.icon" files="model.files" callback="onFileSelectionChanged"></select-add-file>'
                                    }, {
                                        dataField: 'legendItems[' + index + '].color',
                                        label: {
                                            text: i18n('Popup', 'Color')
                                        },
                                        editorType: 'dxColorBox',
                                        editorOptions: {
                                            applyValueMode: 'instantly',
                                            editAlphaChannel: true
                                        }
                                    }
                                ]
                            })
                        })
                    }

                    formItems.push({
                        itemType: 'simple',
                        label: {
                            visible: false
                        },
                        template: '<form-button options="{ type: \'ADD\', buttonHint: \'' + i18n('Popup', 'AddItem') + '\', elementId: ' + element.id + ', propertyName: \'legendItems\'}" callback="onFormButtonClicked"></form-button>'
                    })
                    break
                }
                case CommonHelper.DashboardItemType.Schema: {
                    group.items.push(...[
                        <DevExpress.ui.dxFormSimpleItem>{
                            dataField: 'correlationType',
                            label: {
                                text: i18n('Popup', 'CorrelationType')
                            },
                            editorType: 'dxSelectBox',
                            editorOptions: {
                                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                dataSource: this.correlationType,
                                displayExpr: 'value',
                                valueExpr: 'id',
                            }
                        }
                    ])
                    if (element.data.schemas) {
                        element.data.schemas.forEach((schema, index) => {
                            const formItemId: number = Date.now()

                            formItems.push({
                                itemType: 'group',
                                caption: i18n('Popup', 'Schema') + ' ' + (index + 1),
                                colCount: 1,
                                items: [
                                    {
                                        label: {
                                            visible: false
                                        },
                                        template: '<form-button options="{ type: \'DELETE\', buttonHint: \'' + i18n('Popup', 'DeleteSchema') + '\', elementId: ' + element.id + ', propertyName: \'schemas\', index: ' + index + '}" callback="onFormButtonClicked"></form-button>'
                                    },
                                    {
                                        dataField: 'schemas[' + index + '].referenceType',
                                        label: {
                                            text: i18n('Popup', 'ReferenceType')
                                        },
                                        isRequired: true,
                                        editorType: 'dxSelectBox',
                                        editorOptions: {
                                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                                            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                                            dataSource: this.activeViews,
                                            displayExpr: 'caption',
                                            valueExpr: 'idReferenceType',
                                            showClearButton: true
                                        }
                                    },
                                    {
                                        formItemId: formItemId,
                                        formItemValidateBy: 'schemas.' + index + '.idObject',
                                        dataField: 'referenceValue',
                                        label: {
                                            text: i18n('Popup', 'ReferenceValue')
                                        },
                                        isRequired: true,
                                        template: '<select-popover ng-if="' + (this.$scope.editedItem ? 'editedItem.data.schemas[' + index + '].referenceType' : 'newItem.data.schemas[' + index + '].referenceType') + '" selected-id="' + element.data.schemas[index].idObject + '" datatype-id="' + formItemId + '" options="{ referenceTypeId: ' + (this.$scope.editedItem ? 'editedItem.data.schemas[' + index + '].referenceType' : 'newItem.data.schemas[' + index + '].referenceType') + '}" script-arg="data.schemas.' + index + '.idObject" callback="::onReferenceObjectChanged"></select-popover>'
                                    }
                                ]
                            })
                        })
                    }

                    formItems.push({
                        itemType: 'simple',
                        label: {
                            visible: false
                        },
                        template: '<form-button options="{ type: \'ADD\', buttonHint: \'' + i18n('Popup', 'AddSchema') + '\', elementId: ' + element.id + ', propertyName: \'schemas\'}" callback="onFormButtonClicked"></form-button>'
                    })
                    break
                }
            }
        }

        this.editGroupFormDefer.promise.then(form => {
            this.addCommonSettingsToForm(formItems, element, promises).then(() => {
                // add items after common
                if (formItems[0].itemsAfterCommon.length)
                    formItems[0].items.push(...formItems[0].itemsAfterCommon)
                form.option('items', formItems)

                this.addCommonFormData(formData, element, promises)
                this.$timeout(() => {
                    form.option('formData', formData)
                }, 0)

                this.$scope.isEditPopupLoading = false
            })
        })
    }

    addCommonSettingsToForm(formItems: any[], element, promises) {
        return this.$q.all(promises).then(() => {
            formItems.forEach(formItem => {
                if (formItem.items) {
                    formItem.items.forEach(item => {
                        if (!item.editorOptions) item.editorOptions = {}
                        if (!item.editorOptions.onValueChanged)
                            item.editorOptions.onValueChanged = (e: any) => {
                                this.updateDashboardItems(element.id)
                            }
                    })
                }
            })

            if (element.isCustomizable && element.type != CommonHelper.DashboardItemType.Card && element.type != CommonHelper.DashboardItemType.Schema) {
                if (this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_DASHBOARD_ITEM_CONFIGURATION)) {
                    var base64: any = require('js-base64').Base64
                    var currentScript = base64.encode(element.script)
                    formItems[0].items.push({
                        dataField: 'script',
                        label: {
                            text: i18n('Popup', 'Script')
                        },
                        cssClass: 'script',
                        template: '<popup-script current="' + currentScript + '" database-type="' + element.databaseType + '" element-id="' + element.id + '" property-name="script" callback="onScriptChanged"></popup-script>',
                        editorOptions: {
                            onValueChanged: (e: any) => {
                                element.script = e.value
                                this.updateDashboardItems(element.id)
                            },
                            autoResizeEnabled: true
                        }
                    })
                }
            }

            formItems[0].items.push({
                dataField: 'sizeX',
                label: {
                    text: i18n('Common', 'Width')
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                    items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(el => {
                        return {
                            caption: this.calculateElementWidthPxByColumns(el) + '%',
                            value: el
                        }
                    }),
                    displayExpr: 'caption',
                    valueExpr: 'value',
                    onValueChanged: (e: any) => {
                        element.size = e.value
                        this.updateDashboardItems(element.id)
                    }
                }
            })
        })
    }

    addCommonFormData(formData: any, element, promises) {
        this.$q.all(promises).then(() => {
            if (!formData)
                formData = {}

            if (element.isCustomizable) {
                formData['script'] = element.script
            }
            formData['sizeX'] = element.size
        })
    }

    trim(str) {
        return str.replace(/^\s+|\s+$/gm, '');
    }

    numberToHex(n: number) {
        var s = n.toString(16)
        return "00".substr(0, 2 - s.length) + s
    }

    rgbaToHex(rgba) {
        var parts = rgba.substring(rgba.indexOf("(")).split(","),
            r = parseInt(this.trim(parts[0].substring(1)), 10),
            g = parseInt(this.trim(parts[1]), 10),
            b = parseInt(this.trim(parts[2]), 10);
        const a = parseFloat(this.trim(parts[3].substring(0, parts[3].length - 1)));


        return ('#' + this.numberToHex(r) + this.numberToHex(g) + this.numberToHex(b) + this.numberToHex(+(a * 255).toFixed(0)));
    }

    hexToRgbA(hex) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 4) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)';
        } else if (/^#([A-Fa-f0-9]{4}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 4) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2], c[3], c[3]];
            }
            c = '0x' + c.join('');
            return 'rgba(' + [(c >> 24) & 255, (c >> 16) & 255, (c >> 8) & 255, Math.floor(((c & 255) / 255) * 100) / 100].join(',') + ')';
        }
        throw new Error('Bad Hex');
    }

    private showDestinationLevelPopup = (): void => {
        this.$scope.destinationLevelPopupOptions = {
            distributorId: this.$scope.distributorId,
            operatorId: this.$scope.loggedOperatorId,
            onSubmitCallback: this.saveDashboard
        }
    }

    private saveDashboard = (destination: DestinationLevelModel): void => {
        this.$scope.isApplyButtonClicked = true
        this.$scope.isLoading = true

        const dashboardModel: DashboardSaveModel = new DashboardSaveModel()
        dashboardModel.destinationLevel = destination.destination
        dashboardModel.destinationObject = destination.id
        this.$scope.$root.$broadcast(EventsNames.SHOW_LOADING_INDICATOR)
        if (this.$scope.newDashboardModel) {
            _.assign(dashboardModel, this.$scope.newDashboardModel)
            dashboardModel.rows = []
            dashboardModel.id = 0
            dashboardModel.fitToScreen = !!dashboardModel.fitToScreen
            dashboardModel.keepAspectRatio = !!dashboardModel.keepAspectRatio

            this.api.dashboard.saveDashboardConfiguration(dashboardModel).then((result: ResponseModel) => {
                this.toggleDashboardEditMode(false)

                if (!result.hasErrorCode) {
                    this.$scope.newDashboardModel = null
                    CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationSaved))

                    this.dashboardService.updateSidebarMenu(this.$scope.$root, this.userSession, null, true, this.needUpdateMenu).then(() => {
                        DataProvider.Dashboard.refreshDashboards(this.api, true)
                        this.getDashboardConfig()
                    })
                } else {
                    this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                }
            }).finally(() => {
                this.$scope.isLoading = false
            })
        } else {
            let sortedItems: any[] = _.sortBy(_.sortBy(this.$scope.gridsterItems, 'col'), 'row')

            _.assign(dashboardModel, this.$scope.model)
            dashboardModel.opState = CommonHelper.ChangeState.Modified
            dashboardModel.descriptions = null

            let rows: _.Dictionary<any[]> = _.groupBy(sortedItems, item => item.row)
            let dashboardRows: DashboardRowModel[] = <DashboardRowModel[]>[]
            let counter: number = 0

            DataProvider.Dashboard.getDashboards().then(dashboards => {
                let indexNbr: number = this.calculateGroupIndex(dashboards)
                let itemIndexNbr: number = this.calculateItemIndex(dashboards)

                let groupsIds: number[] = []

                for (let i in rows) {
                    let columns: any[] = rows[i]
                    let dashboardColumns: DashboardColumnModel[] = columns.map((col: any) => {
                        indexNbr++

                        let groupId: number = this.calculateGroupId(dashboards, col, groupsIds)
                        groupsIds.push(groupId)

                        let column: DashboardColumnModel = <DashboardColumnModel>{
                            borderVisible: col.borderVisible,
                            groupId: groupId,
                            height: col.sizeY,
                            size: col.sizeX,
                            indexNbr: indexNbr,
                            opState: this.getDashboardGroupState(col, indexNbr),
                            title: col.title,
                            refreshPeriod: col.refreshPeriod,
                            module: col.module,
                            descr: col.descr,
                            isTemplate: col.isTemplate,
                            column: col['col']
                        }

                        let nonAddedItems: any[] = col.items

                        if (col.opState === Enums.OpChangeState.Delete) {
                            nonAddedItems = col.items.filter((item: any) => item.opState !== Enums.OpChangeState.New)
                        }

                        column.items = nonAddedItems.map(item => {
                            itemIndexNbr++
                            item.indexNbr = itemIndexNbr

                            if (item.data) {
                                item.data.sizeX = undefined
                                item.data.script = undefined
                                item.data.options = undefined

                                if (item.data.backgroundColor && item.data.backgroundColor.indexOf('#') == -1) {
                                    item.data.backgroundColor = this.rgbaToHex(item.data.backgroundColor)
                                }

                                if (item.data.hoverColor && item.data.hoverColor.indexOf('#') == -1) {
                                    item.data.hoverColor = this.rgbaToHex(item.data.hoverColor)
                                }

                                if (item.data.selectColor && item.data.selectColor.indexOf('#') == -1) {
                                    item.data.selectColor = this.rgbaToHex(item.data.selectColor)
                                }

                                if (item.data.shadowColor && item.data.shadowColor.indexOf('#') == -1) {
                                    item.data.shadowColor = this.rgbaToHex(item.data.shadowColor)
                                }

                                if (item.data.borderColor && item.data.borderColor.indexOf('#') == -1) {
                                    item.data.borderColor = this.rgbaToHex(item.data.borderColor)
                                }

                                if (item.data.legendItems && item.data.legendItems.length > 0) {
                                    item.data.legendItems.forEach(legendItem => {
                                        if (legendItem.color && legendItem.color.indexOf('#') == -1) {
                                            legendItem.color = this.rgbaToHex(legendItem.color)
                                        }
                                    })
                                }

                                // Series
                                if (_.isArray(item.data.series)) {
                                    item.data.series.forEach((series: any) => {
                                        if (series != null) {
                                            if (series.seriesColor != null && series.seriesColor.indexOf('#') == -1) {
                                                series.seriesColor = this.rgbaToHex(series.seriesColor)
                                            }
                                            if (series.xTypeName) {
                                                const types = this.types.filter(x => x.value === series.xTypeName)
                                                if (types.length) {
                                                    series.xTypeName = types[0].idDataTypeClass.toString()
                                                }
                                            }
                                        }
                                    })
                                }

                                // Meter
                                if (_.isArray(item.data.ranges)) {
                                    item.data.ranges.forEach((range: any) => {
                                        if (range != null && range.color != null && range.color.indexOf('#') == -1) {
                                            range.color = this.rgbaToHex(range.color)
                                        }
                                    })
                                }

                            }

                            const dashboardItem: DashboardItemModel = <DashboardItemModel>_.assign({}, item)

                            if (item.data && item.type == CommonHelper.DashboardItemType.Card && item.data.option == 1 && item.opState != CommonHelper.ChangeState.Delete) { dashboardItem.opState = item.opState }
                            else dashboardItem.opState = item.opState != CommonHelper.ChangeState.Loaded ? item.opState : column.opState

                            return dashboardItem
                        })

                        counter++
                        return column
                    })

                    dashboardRows.push({ columns: dashboardColumns })
                    counter++
                }

                dashboardModel.rows = dashboardRows

                this.api.dashboard.saveDashboardConfiguration(dashboardModel)
                    .then((result: ResponseModel) => {
                        this.toggleDashboardEditMode(false)

                        if (!result.hasErrorCode) {
                            CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ConfigurationSaved))
                        }

                        if (this.needUpdateMenu) {
                            this.dashboardService.updateSidebarMenu(this.$scope.$root, this.userSession, null, true, this.needUpdateMenu).then(() => {
                                DataProvider.Dashboard.refreshDashboards(this.api, true)
                                this.getDashboardConfig()
                            })
                            this.needUpdateMenu = false
                        } else {
                            DataProvider.Dashboard.refreshDashboards(this.api, true)
                            this.getDashboardConfig()
                            this.$scope.$root.$broadcast(EventsNames.HIDE_LOADING_INDICATOR)
                        }
                    })
                    .finally(() => {
                        this.$scope.isLoading = false
                        this.$scope.isApplyButtonClicked = false
                    })
            })
        }
    }

    private toggleTileGridsterEdit(enable: boolean): void {
        let id: number = null
        if (this.$scope.newItem) {
            id = this.$scope.newItem.id
        }
        if (this.$scope.editedItem) {
            id = this.$scope.editedItem.id
        }
        this.$scope.$broadcast(EventsNames.DASHBOARD_TILE_GRIDSTER_EDIT + id, enable)
    }

    private updateDashboardItems(id: number, data: DashboardDataModel = null): void {
        if (this.updateDashboardItemsTimeout) {
            clearTimeout(this.updateDashboardItemsTimeout)
        }
        this.updateDashboardItemsTimeout = setTimeout(() => {
            this.$scope.$broadcast(EventsNames.UPDATE_DASHBOARD_ITEM + id, data)
        }, 500)
    }


    //#region Dashboard Events

    private onDashboardItemAdded(): void {
        // Timeout so gridster can update row and col values for the new item
        this.$timeout(() => {
            this.updateGridsterRowHeight()
            this.scrollGridsterToItem(_.last(this.$scope.gridsterItems))
        })
    }

    private onDashboardItemRemoved(): void {
        // Timeout so gridster can update itself
        this.$timeout(() => {
            this.updateGridsterRowHeight();
        })
    }

    private onDashboardItemResized(): void {
        this.$timeout(() => {
            this.$scope.$root.$broadcast(EventsNames.REFRESH_GRID_SIZE)
        }, 100)

        this.$timeout(() => {
            this.refreshDashboard()
        }, 1000)
    }

    //#endregion


    //#region Dashboard

    private initializeDashboard(): void {
        (this.$scope as any).isDashboardItemVisible = (item: any) => this.isDashboardItemVisible(item)

        this.initializeMainContainer()
        this.overwriteStyles()
    }

    private isDashboardItemVisible(item: any): boolean {
        return item != null && item.opState !== Enums.OpChangeState.Delete
    }

    private getVisibleGridsterItems(): any[] {
        return _.filter(this.$scope.gridsterItems, item => {
            return item.opState !== Enums.OpChangeState.Delete
        })
    }

    private refreshDashboard(): void {
        this.$scope.$broadcast(EventsNames.DASHBOARD_UPDATE, { time: 0 })
    }

    private toggleDashboardEditMode(isEdit: boolean = false): void {
        this.$scope.isEditMode = isEdit

        this.toggleGridsterEditMode(isEdit)
    }

    //#endregion


    //#region Dashboard Items

    private getDashboardItemModelGroupId(item: DashboardItemModel): number {
        if (item != null) {

            for (const row of this.$scope.model.rows) {
                for (const column of row.columns) {

                    const existingItem: DashboardItemModel = _.find(column.items, (existingItem: DashboardItemModel) => {
                        return item.id === existingItem.id
                    })

                    if (existingItem != null) {
                        return column.groupId
                    }
                }
            }
        }

        return null
    }

    //#endregion


    //#region Gridster Events

    private onGridsterContainerWidthResized(newWidth: number): void {
        if (this.isGridsterKeepAspectRatioMode) {
            this.updateGridsterRowHeight()
        }
    }

    private onGridsterContainerHeightResized(newHeight: number): void {
        if (this.isGridsterFitToScreenMode) {
            this.getDashboardElement().height(newHeight)
            this.updateGridsterRowHeight()
        }
    }

    private onGridsterWidthResized(): void { }

    private onGridsterInitialized(): void { }

    private onGridsterItemResized(item: any): void {
        this.updateGridsterRowHeight()

        this.onDashboardItemResized()
    }

    private onToggleGridsterKeepAspectRatioMode(isKeepAspect: boolean): void {
        this.toggleGridsterScrollViewDisabled()
        this.updateGridsterRowHeight()
    }

    private onToggleGridsterMobileMode(isMobile: boolean): void {
        this.toggleGridsterScrollViewDisabled()
        this.updateGridsterRowHeight()
    }

    private onToggleGridsterEditMode(isEdit: boolean): void {
        this.$scope.gridsterOptions = this.getGridsterOptions(isEdit)

        this.toggleGridsterScrollViewDisabled()
        this.updateGridsterRowHeight()
    }

    private onToggleGridsterFitToScreenMode(isFitToScreen: boolean): void {
        this.toggleGridsterScrollViewDisabled()
        this.updateGridsterRowHeight()
    }

    //#endregion


    //#region Gridster Container

    private gridsterContainerScopeDeregistrationLCallbacks = []

    private getDashboardElement(): JQuery {
        return angular.element('.dashboard')
    }

    private getDashboardContainerElement(): JQuery {
        return angular.element('.dashboard-container')
    }

    private initializeGridsterContainer(): void {
        this.cleanGridsterContainer()

        const dashboardContainerWidthOffWatchFunc = this.$scope.$watch(() => {
            return this.getDashboardContainerElement().width()
        }, _.debounce((newWidth) => {
            this.onGridsterContainerWidthResized(newWidth)
        }, 100))

        const dashboardContainerHeightOffWatchFunc = this.$scope.$watch(() => {
            return this.getDashboardContainerElement().height()
        }, _.debounce((newHeight: number) => {
            this.onGridsterContainerHeightResized(newHeight)
        }, 100))

        this.gridsterContainerScopeDeregistrationLCallbacks.push(dashboardContainerWidthOffWatchFunc)
        this.gridsterContainerScopeDeregistrationLCallbacks.push(dashboardContainerHeightOffWatchFunc)
    }

    private cleanGridsterContainer(): void {
        _.forEach(this.gridsterContainerScopeDeregistrationLCallbacks, (func: () => void) => {
            func()
        })
    }

    //#endregion


    //#region Gridster

    private gridster: any
    private gridsterScroll: DevExpress.ui.dxScrollView

    private isGridsterMobileMode = null
    private isGridsterEditMode = null
    private isGridsterFitToScreenMode = null
    private isGridsterKeepAspectRatioMode = null
    private gridsterScopeDeregistrationLCallbacks = []

    private initializeGridster(): void {
        this.cleanGridster()

        this.$scope.rowHeight = DashboardController.INITIAL_GRIDSTER_HEIGHT
        this.$scope.gridsterOptions = this.getGridsterOptions(this.$scope.isEditMode)

        const gridsterResizedOffFunc: () => void = this.$scope.$on('gridster-resized', (e: any, size: [number, number], gridster) => {
            if (gridster != null && gridster.name === DashboardController.GRIDSTER_NAME) {
                this.onGridsterWidthResized()
            }
        });

        this.gridsterScopeDeregistrationLCallbacks.push(gridsterResizedOffFunc);

        (this.$scope as any).initGridster = (gridster) => {
            this.gridster = gridster

            this.onGridsterInitialized()
        };

        (this.$scope as any).calculateGridsterItemPxHeight = (item: any) => this.calculateGridsterItemPxHeight(item)

        this.initializeGridsterItems()
    }

    private cleanGridster(): void {
        _.forEach(this.gridsterScopeDeregistrationLCallbacks, (func: () => void) => {
            func()
        })

        this.clearGridsterItems()
    }

    private getGridsterOptions(editMode: boolean = false): any {
        if (!editMode) {
            return {
                columns: 12,
                defaultSizeY: 3,
                maxRows: 10000,
                mobileBreakPoint: this.mobileBreakPoint,
                mobileModeEnabled: true,
                name: DashboardController.GRIDSTER_NAME,
                rowHeight: this.$scope.rowHeight,
                saveGridItemCalculatedHeightInMobile: true,

                draggable: {
                    enabled: false
                },
                resizable: {
                    enabled: false
                },
            }
        }

        return {
            columns: 12,
            maxRows: 10000,
            mobileModeEnabled: false,
            name: DashboardController.GRIDSTER_NAME,
            rowHeight: this.$scope.rowHeight,

            resizable: {
                enabled: true,
                handles: ['n', 'e', 's', 'w', 'ne', 'se', 'sw', 'nw'],
            },
            draggable: {
                enabled: true,
                handle: '.dashboard-item-header'
            },
        }
    }

    private getGridsterRowHeight(fitToScreen: boolean = false, keepAspectRatio: boolean = false): string | number {
        if (fitToScreen) {
            return this.getFitToScreenGridsterRowHeight()
        }

        if (keepAspectRatio) {
            return this.getKeepAspectRationGridsterRowHeight()
        }

        return DashboardController.INITIAL_GRIDSTER_HEIGHT
    }

    private getKeepAspectRationGridsterRowHeight(): number {
        const containerWidth: number = this.getDashboardContainerElement().width()

        if (containerWidth > 0) {
            return (containerWidth / DashboardController.INITIAL_GRIDSTER_HEIGHT) / 20
        }

        return this.gridster.curRowHeight
    }

    private getFitToScreenGridsterRowHeight(): number {
        const boundingBox: any = this.gridster.getBoundingBox(this.getVisibleGridsterItems())
        const containerHeight: number = this.getDashboardContainerElement().height()

        if (boundingBox != null && containerHeight > 0) {
            const boundHeight: number = boundingBox.sizeY * this.gridster.curRowHeight

            return this.gridster.curRowHeight * (containerHeight / boundHeight)
        }

        return this.gridster.curRowHeight
    }

    private toggleGridsterEditMode(isEdit: boolean = false): void {
        if (this.isGridsterEditMode == null || this.isGridsterEditMode != isEdit) {
            this.isGridsterEditMode = isEdit

            this.onToggleGridsterEditMode(isEdit)
        }
    }

    private toggleGridsterMobileMode(isMobile: boolean = false): void {
        if (this.isGridsterMobileMode == null || this.isGridsterMobileMode != isMobile) {
            this.isGridsterMobileMode = isMobile

            this.onToggleGridsterMobileMode(isMobile)
        }
    }

    private toggleGridsterFitToScreenMode(isFitToScreen: boolean = false): void {
        if (this.isGridsterFitToScreenMode == null || this.isGridsterFitToScreenMode != isFitToScreen) {
            this.isGridsterFitToScreenMode = isFitToScreen

            this.onToggleGridsterFitToScreenMode(isFitToScreen)
        }
    }

    private toggleGridsterKeepAspectRationMode(isKeepAspectRatio: boolean = false): void {
        if (this.isGridsterKeepAspectRatioMode == null || this.isGridsterKeepAspectRatioMode != isKeepAspectRatio) {
            this.isGridsterKeepAspectRatioMode = isKeepAspectRatio

            this.onToggleGridsterKeepAspectRatioMode(isKeepAspectRatio)
        }
    }

    private updateGridsterRowHeight(): void {
        if (this.gridster != null) {
            let rowHeight: number | string = DashboardController.INITIAL_GRIDSTER_HEIGHT

            if (!this.isGridsterMobileMode) {
                rowHeight = this.getGridsterRowHeight(this.isGridsterFitToScreenMode, this.isGridsterKeepAspectRatioMode)
            }

            this.$scope.rowHeight = rowHeight
            this.$scope.gridsterOptions.rowHeight = rowHeight
        }
    }

    //#endregion


    //#region Gridster Item

    private gridsterItemsDeregistrationsCallbacks = []

    private calculateGridsterItemPxHeight(item: any): number {
        if (item != null && this.gridster != null) {
            return Math.round(this.gridster.curRowHeight * item.sizeY)
        }

        return 0
    }

    private clearGridsterItems(): void {
        _.forEach(this.gridsterItemsDeregistrationsCallbacks, (func: () => void) => {
            func()
        })
    }

    private createGridsterItem(sizeX: number, sizeY: number): any {
        return {
            col: undefined,
            row: undefined,
            sizeX: sizeX,
            sizeY: sizeY,
        }
    }

    private initializeGridsterItems(): void {
        const gridsterItemResizedDebounced = _.debounce((item: any) => {
            this.onGridsterItemResized(item)
        }, 100);

        (this.$scope as any).initGridsterItem = (gridsterItem) => {
            const unwatch = this.$scope.$watch(() => {
                return gridsterItem.$element
            }, ($element: JQuery) => {
                if ($element != null) {
                    const gridsterItemScope: ng.IScope = angular
                        .element($element)
                        .scope()

                    const scopeFunc1 = gridsterItemScope.$on('gridster-item-resized', (e: any, item: any) => {
                        gridsterItemResizedDebounced(item)
                    })

                    const scopeFunc2 = gridsterItemScope.$on('gridster-item-transition-end', (e: any, item: any) => {
                        gridsterItemResizedDebounced(item)
                    })

                    this.gridsterItemsDeregistrationsCallbacks.push(scopeFunc1, scopeFunc2)
                }
            })

            this.gridsterItemsDeregistrationsCallbacks.push(unwatch)
        };
    }

    //#endregion


    //#region Gridster Scroll View

    private initializeScrollView(): void {
        this.$scope.dashboardScrollOptions = {
            direction: 'vertical',
            disabled: true,

            onInitialized: (e: any) => {
                this.gridsterScroll = e.component

                this.toggleGridsterScrollViewDisabled()
            }
        }
    }

    private scrollGridsterToItem(item: any): void {
        if (this.gridster != null && item != null) {
            this.gridsterScroll.scrollTo(item.row * this.gridster.curRowHeight)
        }
    }

    private toggleGridsterScrollViewDisabled(): void {
        if (this.gridsterScroll != null) {
            const enabled: boolean = this.isGridsterMobileMode || !this.isGridsterFitToScreenMode

            this.gridsterScroll.option('disabled', !enabled)

            // Hiding scrollbar because it is sometimes visible even if scroll is disabled
            this.gridsterScroll.option('showScrollbar', enabled)
        }
    }

    //#endregion


    //#region Main Container Events

    private onMainContainerWidthResized(width: number): void {
        // this.isDashboardMobileMode = window.innerWidth < this.mobileBreakPoint
        this.isDashboardMobileMode = width <= this.mobileBreakPoint

        this.updateDashboardHeight(this.isDashboardMobileMode)
        this.toggleGridsterMobileMode(this.isDashboardMobileMode)
    }

    //#endregion


    //#region Main Container

    private getMainContentElement(): JQuery {
        return angular.element('#mainContent')
    }

    private initializeMainContainer(): void {
        this.$scope.$watch(() => {
            return this.getMainContentElement().width()
        }, _.debounce((newWidth: number) => {
            this.onMainContainerWidthResized(newWidth)
        }, 100))
    }

    private overwriteStyles(): void {
        const mainContentDiv: JQuery = angular.element('#mainContent > div')

        // Because when resizing the window, a scroll bar is visible for a sec.
        mainContentDiv.css('overflow', 'hidden')
    }

    private updateDashboardHeight(isMobile: boolean = false): void {
        // angular.element('.sidebar-menu').css('position', 'inherit')

        if (isMobile) {
            const dashboardHeight = window.innerHeight - angular.element('.nav').outerHeight() - angular.element('.sidebar-menu').outerHeight() - 21 //padding of #main-content

            if (dashboardHeight > 0) {
                // Forcing content inside #main-content to have height because in mobile mode #main-content has height set to auto
                angular.element('.dashboard__loading-container').height(dashboardHeight)
            } else {
                angular.element('.dashboard__loading-container').height('100%')
            }
        } else {
            angular.element('.dashboard__loading-container').height('100%')
        }
    }

    //#endregion
}
